export const SecondarySchemeIcon = () => {
  return (
    <svg
      version='1.1'
      id='Layer_1'
      x='0px'
      y='0px'
      width='100%'
      viewBox='0 0 418 408'
      enable-background='new 0 0 418 408'
    >
      <path
        fill='#F9F3F1'
        opacity='1.000000'
        stroke='none'
        d='
  M152.000000,1.000000 
     C190.687561,1.000000 229.375122,1.000000 268.580200,1.366555 
     C269.902588,2.467885 270.585938,3.551953 271.531982,3.881258 
     C278.118896,6.174126 285.170135,7.514774 291.295410,10.669517 
     C302.603027,16.493393 314.451050,21.157095 324.769196,29.181164 
     C334.094879,36.433411 343.968689,43.006905 352.290497,51.444874 
     C358.760742,58.005424 364.525787,65.259026 370.956390,71.861687 
     C377.976837,79.069923 382.955231,87.650803 387.932648,96.192741 
     C391.962097,103.107880 395.415070,110.396530 398.647827,117.729332 
     C403.273895,128.222733 408.306122,138.655807 411.580811,149.589096 
     C414.255371,158.518723 415.550323,168.117569 415.804993,177.464706 
     C416.404297,199.460388 416.634796,221.501923 413.969299,243.431488 
     C413.929230,243.761414 413.940247,244.106918 413.843567,244.419205 
     C411.226379,252.875549 408.698761,261.361481 405.940369,269.771667 
     C403.682037,276.657288 401.494537,283.600159 398.661835,290.256409 
     C392.673126,304.328430 383.867462,316.779663 375.109375,329.201416 
     C371.637360,334.125885 367.994537,339.102814 363.611938,343.176392 
     C354.484283,351.660461 345.099609,359.927612 335.275757,367.584991 
     C326.767517,374.216827 317.985443,380.806427 308.458832,385.744873 
     C296.404999,391.993408 283.508575,396.634308 270.896454,401.774475 
     C268.063354,402.929108 264.922211,403.378815 261.888184,403.977081 
     C257.753113,404.792358 253.559555,405.328857 249.456299,406.269501 
     C248.796890,406.420685 248.476898,408.052582 248.000000,409.000000 
     C221.645767,409.000000 195.291550,409.000000 168.453445,408.593567 
     C166.406509,407.457275 164.889847,406.597351 163.272293,406.020325 
     C156.496414,403.603210 148.630981,404.258545 142.931320,398.765228 
     C142.499283,398.348846 141.747482,398.116913 141.123718,398.069305 
     C133.952805,397.521698 127.855843,394.155731 121.719269,390.838593 
     C120.757996,390.319000 119.488380,390.400848 118.456818,389.973877 
     C116.280495,389.073120 114.110237,388.124207 112.046181,386.996185 
     C110.344681,386.066345 108.906975,384.147217 107.166924,383.881653 
     C99.358055,382.689972 95.583611,374.960480 88.006340,372.812775 
     C83.304398,371.480042 79.451653,366.426331 75.710930,362.565033 
     C65.047920,351.558258 54.290806,340.607117 44.265724,329.032104 
     C38.798172,322.719269 34.735775,315.188629 30.050936,308.199646 
     C29.419580,307.257751 28.802448,306.299408 28.266783,305.301422 
     C24.860739,298.955994 21.059818,292.779510 18.200502,286.194946 
     C14.926801,278.656128 12.491205,270.752930 9.704232,263.003448 
     C9.109035,261.348450 8.429087,259.706116 8.032775,258.001129 
     C7.262874,254.688873 6.666411,251.336304 5.999107,247.547119 
     C5.310027,242.016373 4.730296,236.918854 3.813178,231.882782 
     C3.672456,231.110046 1.976614,230.620514 1.000000,230.000000 
     C1.000000,211.645767 1.000000,193.291550 1.405190,174.452988 
     C2.528521,173.247040 3.720977,172.621887 3.890429,171.788681 
     C5.363311,164.546555 6.652683,157.267120 7.997982,149.560699 
     C8.555543,146.459457 8.885351,143.722656 9.721844,141.150650 
     C10.928942,137.439163 12.411456,133.808075 13.939225,130.211838 
     C18.195381,120.193176 21.677313,109.717293 27.063330,100.340004 
     C33.540035,89.063782 40.836235,78.024765 49.276295,68.166061 
     C61.053020,54.409840 74.309792,41.926353 89.671265,32.023540 
     C95.532059,28.245367 101.574234,24.728188 107.676132,21.349201 
     C116.651711,16.378887 125.737465,11.605759 134.826279,6.844040 
     C135.936447,6.262409 137.350082,6.243505 138.631119,6.007506 
     C142.610046,5.274486 146.620453,4.676997 150.547409,3.731198 
     C151.212296,3.571059 151.524734,1.947460 152.000000,1.000000 
  M112.107292,286.607452 
     C112.714180,287.092865 113.321068,287.578247 113.949890,288.992676 
     C113.974174,290.808716 113.937424,292.627991 114.033470,294.440216 
     C114.423279,301.795532 112.183548,309.640900 117.998909,316.759369 
     C119.834930,319.113373 121.489746,323.293152 123.539215,323.496552 
     C131.266647,324.263489 139.318817,324.789215 146.871262,323.379456 
     C153.535583,322.135437 159.955017,319.842804 166.923065,319.867828 
     C170.416748,319.880371 173.923843,318.822113 177.407700,318.158081 
     C180.905869,317.491333 184.382675,316.712708 188.208511,316.642395 
     C190.634857,320.802124 193.061203,324.961853 195.268478,329.679199 
     C196.514435,334.719696 204.410706,337.829590 210.352020,335.463196 
     C218.448395,332.238464 226.542816,328.994720 234.511063,325.471832 
     C236.609100,324.544312 238.239395,322.558777 240.772690,321.323975 
     C241.720993,321.471619 242.860733,322.034973 243.587067,321.700531 
     C248.990585,319.212677 254.265945,316.445892 259.674561,313.969879 
     C263.706116,312.124268 267.876801,310.582520 272.659424,308.938141 
     C274.057404,308.602814 275.529999,308.447418 276.841522,307.903625 
     C287.171356,303.620636 297.500854,299.333466 307.753845,294.871521 
     C309.866516,293.952118 311.658478,292.295715 314.072815,290.557129 
     C316.051178,290.006012 318.029510,289.454865 320.761536,288.840179 
     C323.827057,287.062134 326.892548,285.284088 330.449585,283.102051 
     C331.311096,281.058350 332.313538,279.060944 333.002625,276.960663 
     C334.175293,273.386475 330.327423,264.113281 327.033661,261.290314 
     C324.190460,253.549377 321.526672,245.735596 318.426727,238.098877 
     C316.922943,234.394241 314.094788,230.533554 313.138641,227.410507 
     C311.915436,223.415329 309.141724,219.933258 308.574463,215.163635 
     C307.735626,208.110397 302.230377,201.716736 299.385162,194.766663 
     C296.791718,188.431641 295.316284,181.640152 291.260986,175.923538 
     C290.919037,175.441513 291.032990,174.636108 291.065399,173.330078 
     C290.087128,170.499268 289.232391,167.618423 288.109894,164.846008 
     C282.087097,149.970367 276.225342,135.020844 269.727386,120.354050 
     C268.515045,117.617577 264.657471,116.053047 261.656128,113.331360 
     C261.290833,113.025467 260.973846,112.577652 260.553162,112.434364 
     C249.229935,108.577393 237.911011,104.706650 226.559174,100.935135 
     C217.729919,98.001709 208.857407,95.198494 199.318024,92.002663 
     C195.797577,90.721176 192.227493,89.559998 188.767441,88.132172 
     C182.338531,85.479225 176.200180,84.674850 170.569519,89.965599 
     C170.069458,90.435471 168.976517,90.274391 167.690201,89.863914 
     C165.058975,87.558403 162.643509,84.926231 159.751190,83.016052 
     C153.907211,79.156509 147.804321,75.688995 141.298065,71.611671 
     C135.820221,68.749756 130.096390,66.580688 123.998589,69.088928 
     C118.929680,71.173943 114.775864,74.631287 114.022484,80.534615 
     C113.011253,88.458435 115.346916,95.190948 122.022804,100.824326 
     C124.081123,102.914597 125.861893,105.418869 128.248779,107.019035 
     C136.020111,112.228943 144.012939,117.108444 152.048965,122.944611 
     C151.991638,124.615265 151.934296,126.285919 151.237091,128.148666 
     C150.181595,129.509155 149.126099,130.869659 147.333923,132.175217 
     C144.949661,134.149643 142.565414,136.124069 139.482254,138.137314 
     C136.757935,140.680908 133.985306,143.176483 131.360428,145.818863 
     C130.957870,146.224106 131.236801,147.306320 131.014099,148.782074 
     C125.436562,155.240616 119.859032,161.699173 113.565720,168.149475 
     C110.410156,171.465622 107.254593,174.781754 103.384216,178.192337 
     C97.560295,183.003723 96.218475,189.846405 98.393311,196.101105 
     C101.595436,205.310287 102.022469,214.508301 102.214653,223.976547 
     C102.256676,226.046829 104.623878,228.069946 105.946579,231.027710 
     C105.973236,236.133499 105.958366,241.239960 106.042526,246.344803 
     C106.091072,249.289825 105.242302,252.937088 106.642929,255.037842 
     C110.220360,260.403625 110.076080,266.108246 110.024933,272.903351 
     C110.021103,276.002991 109.822716,279.120514 110.105591,282.193756 
     C110.225021,283.491302 111.358231,284.695557 112.018715,285.981537 
     C112.018715,285.981537 112.058998,285.973358 112.107292,286.607452 
  M99.173080,118.146301 
     C97.088135,121.306374 97.296883,124.256622 99.995506,126.966583 
     C104.781059,131.772232 109.546516,136.598282 114.369431,141.366180 
     C118.084366,145.038727 118.889503,144.872375 122.757088,139.835907 
     C122.723564,137.807968 123.537262,135.018250 122.514008,133.880219 
     C117.298737,128.079971 111.713272,122.595352 106.024818,117.247627 
     C104.159248,115.493805 101.620949,114.703529 99.173080,118.146301 
  M84.002747,309.998047 
     C84.002747,309.998047 84.092781,309.889832 84.182854,310.634430 
     C86.058929,310.788269 88.732445,311.817566 89.681183,310.953369 
     C95.679764,305.489288 101.630898,299.883972 106.803032,293.664490 
     C108.092659,292.113708 107.353973,287.551300 105.956009,285.414215 
     C104.061180,282.517548 101.059685,283.888824 98.811462,286.159210 
     C93.912552,291.106384 88.927101,295.968750 84.071075,300.957336 
     C80.997726,304.114563 81.094002,307.441711 84.002747,309.998047 
  M285.329865,91.242645 
     C282.823456,93.305573 281.817291,95.781105 284.168854,98.444214 
     C286.808685,101.433792 289.250885,99.550575 291.325623,97.510818 
     C295.888489,93.024857 300.404083,88.486084 304.797607,83.835350 
     C306.163910,82.389099 307.075836,80.513634 308.261230,78.736542 
     C306.376129,77.716354 305.098114,77.024704 303.823395,75.590347 
     C302.945435,75.146828 301.698090,74.083084 301.244965,74.352936 
     C294.543579,78.343941 289.394562,83.835709 285.329865,91.242645 
  M208.672516,81.980629 
     C209.649765,81.480103 210.753220,81.132980 211.581650,80.451530 
     C214.603790,77.965553 211.991898,75.101105 211.992081,72.403152 
     C211.992538,64.928528 211.949371,57.453621 212.003204,49.979397 
     C212.033264,45.806252 210.020264,43.870365 205.909088,44.014542 
     C200.592896,44.200977 200.308212,48.473793 200.140106,52.007782 
     C199.777496,59.631329 199.702927,67.305687 200.214020,74.911987 
     C200.375931,77.321846 202.768417,79.581833 204.894150,81.965721 
     C205.902588,81.960899 206.911026,81.956070 208.672516,81.980629 
  M330.488922,173.932159 
     C324.516388,173.935654 318.530396,173.714355 312.579071,174.071365 
     C310.642639,174.187515 308.796814,175.813995 306.909576,176.749695 
     C308.727539,178.394867 310.548859,181.453430 312.362946,181.449142 
     C322.033295,181.426376 331.707672,180.714462 341.361664,179.988297 
     C342.280273,179.919189 343.891846,177.925537 343.723175,177.137573 
     C343.467590,175.943512 342.033600,174.282379 340.919800,174.128845 
     C337.824219,173.702072 334.635590,173.950378 330.488922,173.932159 
  M49.819649,209.452805 
     C50.951286,210.358170 52.067150,212.025177 53.217049,212.048981 
     C62.833248,212.248108 72.459557,212.272995 82.071709,211.982605 
     C83.373062,211.943283 84.612801,209.865005 85.881073,208.730835 
     C84.612343,207.802246 83.362167,206.099472 82.071938,206.068558 
     C72.455841,205.838196 62.829998,205.851700 53.212650,206.051041 
     C52.062408,206.074875 50.944824,207.674347 49.819649,209.452805 
  M170.032242,76.223251 
     C170.970032,76.649010 171.907837,77.074768 172.910233,77.529854 
     C172.910233,74.604614 173.412567,72.399002 172.809586,70.554794 
     C171.390457,66.214439 169.599487,61.970940 167.602997,57.861172 
     C167.092941,56.811230 165.256592,56.405594 164.029602,55.703934 
     C163.470718,57.054497 162.105270,58.717060 162.486954,59.703800 
     C164.593445,65.149536 167.126221,70.430382 170.032242,76.223251 
  M334.913696,216.698486 
     C329.758240,214.788239 324.602753,212.878006 317.897827,210.393646 
     C319.240173,213.263565 319.633850,216.138809 321.138000,216.946808 
     C326.007812,219.562698 331.247131,221.521606 336.443756,223.467545 
     C337.299011,223.787796 339.490570,222.928467 339.605255,222.333160 
     C339.833862,221.146469 339.342102,219.546738 338.588623,218.533508 
     C338.005066,217.748749 336.570648,217.596710 334.913696,216.698486 
  M294.412842,142.424850 
     C302.396179,140.510620 310.500092,138.809708 315.059631,130.675262 
     C307.694519,132.608719 300.740723,135.400452 293.900391,138.446930 
     C293.458893,138.643555 293.892151,140.804306 294.412842,142.424850 
  M95.264328,168.174911 
     C90.955086,166.309540 86.714890,164.245941 82.292480,162.705475 
     C81.045158,162.270996 79.264122,163.368729 77.727882,163.763702 
     C78.456200,165.089874 78.859810,167.075958 79.971519,167.622971 
     C83.874115,169.543198 87.988533,171.055725 92.086494,172.547287 
     C94.412857,173.394028 96.863792,173.898544 99.258621,174.557175 
     C99.659782,173.914871 100.060951,173.272583 100.462112,172.630295 
     C98.975494,171.209732 97.488884,169.789185 95.264328,168.174911 
  M251.694321,74.491432 
     C251.804764,74.009010 252.065948,73.504364 251.998703,73.048126 
     C251.749786,71.359154 251.392471,69.686157 251.075897,68.007156 
     C249.960907,69.100906 248.432922,69.999031 247.805511,71.323715 
     C245.596878,75.986954 243.580139,80.752472 241.761765,85.581299 
     C241.297348,86.814568 241.832489,88.424225 241.908386,89.860947 
     C243.310104,88.933617 245.283997,88.322891 246.005417,87.019127 
     C248.100250,83.233391 249.692841,79.169739 251.694321,74.491432 
  M77.338333,253.882141 
     C73.262169,254.933670 69.607368,256.443542 68.850754,261.394928 
     C75.710732,261.985962 90.963875,254.503204 91.157051,250.567261 
     C86.791748,251.584351 82.437767,252.598785 77.338333,253.882141 
  z'
      />
      <path
        fill='#00000000'
        opacity='1.000000'
        stroke='none'
        d='
  M248.468658,409.000000 
     C248.476898,408.052582 248.796890,406.420685 249.456299,406.269501 
     C253.559555,405.328857 257.753113,404.792358 261.888184,403.977081 
     C264.922211,403.378815 268.063354,402.929108 270.896454,401.774475 
     C283.508575,396.634308 296.404999,391.993408 308.458832,385.744873 
     C317.985443,380.806427 326.767517,374.216827 335.275757,367.584991 
     C345.099609,359.927612 354.484283,351.660461 363.611938,343.176392 
     C367.994537,339.102814 371.637360,334.125885 375.109375,329.201416 
     C383.867462,316.779663 392.673126,304.328430 398.661835,290.256409 
     C401.494537,283.600159 403.682037,276.657288 405.940369,269.771667 
     C408.698761,261.361481 411.226379,252.875549 413.843567,244.419205 
     C413.940247,244.106918 413.929230,243.761414 413.969299,243.431488 
     C416.634796,221.501923 416.404297,199.460388 415.804993,177.464706 
     C415.550323,168.117569 414.255371,158.518723 411.580811,149.589096 
     C408.306122,138.655807 403.273895,128.222733 398.647827,117.729332 
     C395.415070,110.396530 391.962097,103.107880 387.932648,96.192741 
     C382.955231,87.650803 377.976837,79.069923 370.956390,71.861687 
     C364.525787,65.259026 358.760742,58.005424 352.290497,51.444874 
     C343.968689,43.006905 334.094879,36.433411 324.769196,29.181164 
     C314.451050,21.157095 302.603027,16.493393 291.295410,10.669517 
     C285.170135,7.514774 278.118896,6.174126 271.531982,3.881258 
     C270.585938,3.551953 269.902588,2.467885 269.048828,1.366555 
     C318.969971,1.000000 368.939972,1.000000 418.954956,1.000000 
     C418.954956,136.888306 418.954956,272.776642 418.954956,409.000000 
     C362.312866,409.000000 305.625092,409.000000 248.468658,409.000000 
  z'
      />
      <path
        fill='#00000000'
        opacity='1.000000'
        stroke='none'
        d='
  M5.998096,248.000443 
     C6.666411,251.336304 7.262874,254.688873 8.032775,258.001129 
     C8.429087,259.706116 9.109035,261.348450 9.704232,263.003448 
     C12.491205,270.752930 14.926801,278.656128 18.200502,286.194946 
     C21.059818,292.779510 24.860739,298.955994 28.266783,305.301422 
     C28.802448,306.299408 29.419580,307.257751 30.050936,308.199646 
     C34.735775,315.188629 38.798172,322.719269 44.265724,329.032104 
     C54.290806,340.607117 65.047920,351.558258 75.710930,362.565033 
     C79.451653,366.426331 83.304398,371.480042 88.006340,372.812775 
     C95.583611,374.960480 99.358055,382.689972 107.166924,383.881653 
     C108.906975,384.147217 110.344681,386.066345 112.046181,386.996185 
     C114.110237,388.124207 116.280495,389.073120 118.456818,389.973877 
     C119.488380,390.400848 120.757996,390.319000 121.719269,390.838593 
     C127.855843,394.155731 133.952805,397.521698 141.123718,398.069305 
     C141.747482,398.116913 142.499283,398.348846 142.931320,398.765228 
     C148.630981,404.258545 156.496414,403.603210 163.272293,406.020325 
     C164.889847,406.597351 166.406509,407.457275 167.984787,408.593567 
     C112.406761,409.000000 56.813522,409.000000 1.000000,409.000000 
     C1.000000,354.312622 1.000000,299.624969 1.350945,244.511322 
     C3.133958,245.390381 4.566027,246.695404 5.998096,248.000443 
  z'
      />
      <path
        fill='#00000000'
        opacity='1.000000'
        stroke='none'
        d='
  M151.531342,1.000000 
     C151.524734,1.947460 151.212296,3.571059 150.547409,3.731198 
     C146.620453,4.676997 142.610046,5.274486 138.631119,6.007506 
     C137.350082,6.243505 135.936447,6.262409 134.826279,6.844040 
     C125.737465,11.605759 116.651711,16.378887 107.676132,21.349201 
     C101.574234,24.728188 95.532059,28.245367 89.671265,32.023540 
     C74.309792,41.926353 61.053020,54.409840 49.276295,68.166061 
     C40.836235,78.024765 33.540035,89.063782 27.063330,100.340004 
     C21.677313,109.717293 18.195381,120.193176 13.939225,130.211838 
     C12.411456,133.808075 10.928942,137.439163 9.721844,141.150650 
     C8.885351,143.722656 8.555543,146.459457 7.652788,149.600143 
     C5.204157,151.718445 3.102078,153.359222 1.000000,155.000000 
     C1.000000,103.740379 1.000000,52.480762 1.000000,1.000000 
     C51.020676,1.000000 101.041679,1.000000 151.531342,1.000000 
  z'
      />
      <path
        fill='#FEFCFA'
        opacity='1.000000'
        stroke='none'
        d='
  M1.000000,155.468277 
     C3.102078,153.359222 5.204157,151.718445 7.651430,150.038223 
     C6.652683,157.267120 5.363311,164.546555 3.890429,171.788681 
     C3.720977,172.621887 2.528521,173.247040 1.405190,173.984329 
     C1.000000,167.978851 1.000000,161.957703 1.000000,155.468277 
  z'
      />
      <path
        fill='#FEFCFA'
        opacity='1.000000'
        stroke='none'
        d='
  M5.999107,247.547119 
     C4.566027,246.695404 3.133958,245.390381 1.350945,244.042664 
     C1.000000,239.643097 1.000000,235.286194 1.000000,230.464645 
     C1.976614,230.620514 3.672456,231.110046 3.813178,231.882782 
     C4.730296,236.918854 5.310027,242.016373 5.999107,247.547119 
  z'
      />
      <path
        fill='#D63C3E'
        opacity='1.000000'
        stroke='none'
        d='
  M271.985504,308.905426 
     C267.876801,310.582520 263.706116,312.124268 259.674561,313.969879 
     C254.265945,316.445892 248.990585,319.212677 243.587067,321.700531 
     C242.860733,322.034973 241.720993,321.471619 240.048096,321.314178 
     C235.537247,322.810699 231.766113,324.356476 227.960907,325.813263 
     C223.300171,327.597656 218.522476,329.105713 213.958542,331.105682 
     C209.272125,333.159332 198.415787,332.212128 195.487564,329.121582 
     C193.061203,324.961853 190.634857,320.802124 188.072662,315.991394 
     C187.922043,314.909119 187.907257,314.477814 188.250458,313.971405 
     C188.978775,312.952728 189.901978,311.796875 189.633835,311.098450 
     C186.954178,304.118652 184.233658,297.144836 181.185562,290.320770 
     C179.864639,287.363464 177.754639,284.758636 176.001129,281.596558 
     C169.165329,263.259979 162.906448,245.082748 153.997269,227.603638 
     C153.320572,224.931992 152.954453,222.502518 151.906876,220.415039 
     C149.449615,215.518417 146.666183,210.785461 144.012527,205.565155 
     C143.664703,203.418045 143.568054,201.593552 142.930695,199.983047 
     C140.092331,192.810928 136.336090,185.894913 134.446350,178.494431 
     C133.299637,174.003769 132.673126,168.795578 136.492264,163.954590 
     C138.517899,161.386993 141.320847,157.329498 139.014771,152.735214 
     C138.991348,152.487671 139.060837,151.995239 139.431549,151.986969 
     C141.187057,150.731705 143.051788,149.739746 143.873474,148.193527 
     C147.406372,141.545319 150.632828,134.734283 154.038345,127.632050 
     C156.634323,122.518272 159.668488,117.943947 161.539993,112.935188 
     C163.197586,108.498947 165.944717,107.560844 169.999481,108.346329 
     C170.031113,109.079964 170.041809,109.499397 169.711609,109.990067 
     C161.390106,115.579483 160.899887,125.486702 156.082962,132.877670 
     C154.360764,135.520203 153.721832,138.842819 152.311096,141.718979 
     C147.449249,151.631073 142.451111,161.476257 137.554214,171.371368 
     C137.174194,172.139297 136.800232,173.235733 137.061615,173.944000 
     C139.129898,179.548279 141.228531,185.148392 143.567169,190.643677 
     C145.518539,195.228897 148.015762,199.585327 149.899704,204.194916 
     C153.138840,212.120453 155.897491,220.244568 159.213791,228.135727 
     C162.523621,236.011536 167.103485,243.449509 169.576050,251.552551 
     C171.763657,258.721680 174.564178,265.402740 177.880280,272.069397 
     C181.730270,279.809326 184.667694,288.003174 188.000275,296.333282 
     C188.004135,297.110870 188.008926,297.555206 188.055984,298.317169 
     C188.729706,299.093231 189.361160,299.551666 189.993179,300.418396 
     C190.659851,302.556824 191.325958,304.286926 191.992615,306.262695 
     C191.993164,306.508392 191.998337,306.999756 192.003677,307.352081 
     C192.669846,308.475494 193.330673,309.246613 193.993790,310.414154 
     C195.335587,315.207245 196.675079,319.603882 198.055908,324.318451 
     C198.731293,325.090912 199.365341,325.545471 200.068817,326.355103 
     C201.421097,327.142334 202.703934,327.574493 204.061646,328.355469 
     C205.111176,329.031372 206.307755,329.895508 207.024963,329.599243 
     C212.112869,327.497528 217.090424,325.130646 222.127075,322.902283 
     C227.320175,320.604736 232.492691,318.250061 237.758148,316.128754 
     C250.509644,310.991455 263.353302,306.080811 276.067963,300.855286 
     C280.740662,298.934845 285.015747,296.027985 289.716431,294.198639 
     C299.033661,290.572693 308.668182,287.738434 317.894958,283.910370 
     C326.596130,280.300354 327.092010,278.952545 326.407166,271.996887 
     C327.868805,271.999084 328.931854,272.000763 330.002075,272.446075 
     C329.995941,275.257965 329.982635,277.626221 329.637024,280.054596 
     C327.279022,281.940399 325.229767,283.740875 323.236725,285.601593 
     C322.112610,286.651062 321.081085,287.799744 320.007874,288.903748 
     C318.029510,289.454865 316.051178,290.006012 313.450867,290.767761 
     C308.699615,292.169708 303.946198,291.686310 300.837067,295.677948 
     C300.420654,296.212616 298.901672,295.769684 297.977936,296.054291 
     C296.331238,296.561584 294.748596,297.277283 293.140259,297.908539 
     C287.948883,299.946106 282.872070,302.403229 277.523010,303.862274 
     C274.440552,304.703033 272.325165,305.539429 271.985504,308.905426 
  z'
      />
      <path
        fill='#474C5F'
        opacity='1.000000'
        stroke='none'
        d='
  M151.920532,122.115089 
     C144.012939,117.108444 136.020111,112.228943 128.248779,107.019035 
     C125.861893,105.418869 124.081123,102.914597 122.000092,100.072037 
     C120.473282,95.753876 119.122383,92.113571 117.433693,88.637360 
     C113.739655,81.033104 119.081474,71.991814 127.418640,71.974068 
     C132.215073,71.963852 137.011688,72.028725 141.808212,72.059807 
     C147.804321,75.688995 153.907211,79.156509 159.751190,83.016052 
     C162.643509,84.926231 165.058975,87.558403 167.940948,90.438683 
     C169.668442,92.541512 171.036392,94.197281 172.646423,95.568901 
     C175.325790,97.851509 178.160385,99.951904 181.055939,102.411217 
     C182.381256,103.830025 183.580261,104.966660 184.832581,106.468750 
     C187.877136,110.602150 190.868378,114.370087 193.822998,118.542648 
     C194.313187,120.049530 194.942764,121.115524 195.347015,122.261047 
     C196.445404,125.373482 197.499161,128.520355 193.802002,130.794876 
     C190.391556,132.893036 189.049728,130.215118 187.422928,128.094055 
     C186.289139,126.615761 185.078735,125.196205 183.937683,123.406296 
     C182.645279,121.378769 181.317719,119.695358 179.996185,117.638046 
     C176.661392,113.525826 173.320618,109.787521 169.988525,106.024048 
     C169.997223,105.998886 169.948059,106.019363 169.906204,105.704430 
     C169.240616,104.947937 168.616867,104.506371 167.992889,104.038712 
     C167.992676,104.012611 167.940811,104.006737 167.913940,103.677078 
     C166.630905,102.273117 165.374741,101.198830 163.821716,99.932617 
     C157.663651,94.964920 151.857574,90.119041 145.915253,85.446419 
     C143.388947,83.459900 140.577301,81.836235 138.210236,79.979820 
     C138.216202,78.840485 138.006088,76.881721 137.583008,76.834595 
     C133.294907,76.356911 128.972015,76.191376 124.658882,75.938316 
     C124.633675,76.452316 124.608467,76.966316 124.583260,77.480309 
     C125.168587,77.716034 125.753914,77.951752 126.283272,78.582687 
     C123.129974,81.609650 123.185188,84.761650 124.931519,88.021271 
     C129.751205,97.017494 138.153824,102.236061 146.097763,107.940544 
     C149.058777,110.066833 151.912323,112.342766 155.110153,114.818619 
     C156.969589,118.781090 155.229202,120.836891 151.920532,122.115089 
  z'
      />
      <path
        fill='#D23D41'
        opacity='1.000000'
        stroke='none'
        d='
  M329.994873,272.002441 
     C328.931854,272.000763 327.868805,271.999084 326.339447,271.646637 
     C321.927734,262.911621 317.734894,254.632782 314.106323,246.113632 
     C310.441742,237.509933 307.457916,228.618820 303.943970,219.947571 
     C301.569794,214.088913 298.653717,208.451248 296.229401,202.611221 
     C292.139740,192.759583 288.186951,182.849747 284.291016,172.919495 
     C280.747925,163.888580 277.526459,154.727737 273.813782,145.768951 
     C272.376312,142.300278 269.978607,139.229568 268.014709,135.581390 
     C266.007172,130.778610 264.003174,126.371971 261.952454,121.652626 
     C261.275726,120.893349 260.645691,120.446793 259.650818,119.930702 
     C254.014282,117.914963 248.735321,115.988121 243.473450,114.015686 
     C240.003845,112.715096 236.607452,111.201027 233.091843,110.045525 
     C227.311691,108.145737 221.478088,106.402283 215.636673,104.696861 
     C207.772552,102.400917 199.879654,100.203613 191.952255,97.651260 
     C191.274551,96.893005 190.643677,96.447456 189.636902,95.928650 
     C185.502258,95.235428 181.743530,94.615463 177.651871,93.997116 
     C176.874695,94.001274 176.430466,94.003807 175.636322,93.931870 
     C175.303070,92.629677 174.821625,90.871872 175.443130,90.287872 
     C176.628525,89.174026 178.442978,88.729660 180.070450,88.362244 
     C181.440048,89.129593 182.735504,89.542053 184.431061,89.964310 
     C189.878723,91.326363 194.926239,92.678619 200.067474,94.396759 
     C205.441696,96.510262 210.722183,98.257874 216.048721,100.322311 
     C216.732285,101.079155 217.369827,101.519188 218.428680,101.969368 
     C220.173309,102.066399 221.606567,101.851219 222.802917,102.286789 
     C235.065994,106.751480 247.286026,111.334251 259.537323,115.831635 
     C260.278870,116.103859 261.183716,115.931198 262.371948,116.019142 
     C265.120270,119.239494 268.202698,122.100487 269.760590,125.633690 
     C273.544983,134.216721 276.569855,143.132187 280.001617,151.874115 
     C281.998566,156.961014 283.522644,162.433838 286.565979,166.828232 
     C288.173615,169.149567 285.903229,173.981583 290.935150,173.980927 
     C291.032990,174.636108 290.919037,175.441513 291.260986,175.923538 
     C295.316284,181.640152 296.791718,188.431641 299.385162,194.766663 
     C302.230377,201.716736 307.735626,208.110397 308.574463,215.163635 
     C309.141724,219.933258 311.915436,223.415329 313.138641,227.410507 
     C314.094788,230.533554 316.922943,234.394241 318.426727,238.098877 
     C321.526672,245.735596 324.190460,253.549377 326.967102,262.039398 
     C327.931976,265.859802 328.963440,268.931122 329.994873,272.002441 
  z'
      />
      <path
        fill='#E2B24F'
        opacity='1.000000'
        stroke='none'
        d='
  M330.986328,173.932098 
     C334.635590,173.950378 337.824219,173.702072 340.919800,174.128845 
     C342.033600,174.282379 343.467590,175.943512 343.723175,177.137573 
     C343.891846,177.925537 342.280273,179.919189 341.361664,179.988297 
     C331.707672,180.714462 322.033295,181.426376 312.362946,181.449142 
     C310.548859,181.453430 308.727539,178.394867 306.909576,176.749695 
     C308.796814,175.813995 310.642639,174.187515 312.579071,174.071365 
     C318.530396,173.714355 324.516388,173.935654 330.986328,173.932098 
  z'
      />
      <path
        fill='#FAECC5'
        opacity='1.000000'
        stroke='none'
        d='
  M204.140137,81.910400 
     C202.768417,79.581833 200.375931,77.321846 200.214020,74.911987 
     C199.702927,67.305687 199.777496,59.631329 200.140106,52.007782 
     C200.308212,48.473793 200.592896,44.200977 205.909088,44.014542 
     C210.020264,43.870365 212.033264,45.806252 212.003204,49.979397 
     C211.949371,57.453621 211.992538,64.928528 211.992081,72.403152 
     C211.991898,75.101105 214.603790,77.965553 211.581650,80.451530 
     C210.753220,81.132980 209.649765,81.480103 208.373535,81.588051 
     C208.656006,79.383423 209.577484,77.601784 209.742874,75.752518 
     C210.023026,72.620499 209.829117,69.445763 209.828217,66.288979 
     C209.826752,61.138454 210.145325,55.955219 209.632156,50.855904 
     C209.462204,49.167206 207.145264,47.694572 205.809952,46.123154 
     C205.146759,47.589336 203.919662,49.052124 203.910797,50.522251 
     C203.847717,60.984127 204.033539,71.447502 204.140137,81.910400 
  z'
      />
      <path
        fill='#FAECC5'
        opacity='1.000000'
        stroke='none'
        d='
  M187.892456,314.046539 
     C187.907257,314.477814 187.922043,314.909119 187.902832,315.661743 
     C184.382675,316.712708 180.905869,317.491333 177.407700,318.158081 
     C173.923843,318.822113 170.416748,319.880371 166.923065,319.867828 
     C159.955017,319.842804 153.535583,322.135437 146.871262,323.379456 
     C139.318817,324.789215 131.266647,324.263489 123.539215,323.496552 
     C121.489746,323.293152 119.834930,319.113373 118.308212,316.380402 
     C119.031418,316.002167 119.445335,316.002899 119.971619,316.345703 
     C123.665955,321.762024 128.823257,322.670685 134.436295,321.800079 
     C146.309479,319.958527 158.153946,317.931946 170.431976,316.031921 
     C175.913147,315.318146 180.972534,314.553711 186.337158,313.862000 
     C187.059097,313.971954 187.475769,314.009247 187.892456,314.046539 
  z'
      />
      <path
        fill='#E6B75D'
        opacity='1.000000'
        stroke='none'
        d='
  M303.820099,76.333038 
     C305.098114,77.024704 306.376129,77.716354 308.261230,78.736542 
     C307.075836,80.513634 306.163910,82.389099 304.797607,83.835350 
     C300.404083,88.486084 295.888489,93.024857 291.325623,97.510818 
     C289.250885,99.550575 286.808685,101.433792 284.168854,98.444214 
     C281.817291,95.781105 282.823456,93.305573 285.997925,91.003235 
     C289.816254,88.081642 292.955597,85.386505 296.120178,82.721344 
     C298.670959,80.573105 301.252319,78.461113 303.820099,76.333038 
  z'
      />
      <path
        fill='#E4B14F'
        opacity='1.000000'
        stroke='none'
        d='
  M49.815880,208.998154 
     C50.944824,207.674347 52.062408,206.074875 53.212650,206.051041 
     C62.829998,205.851700 72.455841,205.838196 82.071938,206.068558 
     C83.362167,206.099472 84.612343,207.802246 85.881073,208.730835 
     C84.612801,209.865005 83.373062,211.943283 82.071709,211.982605 
     C72.459557,212.272995 62.833248,212.248108 53.217049,212.048981 
     C52.067150,212.025177 50.951286,210.358170 49.815880,208.998154 
  z'
      />
      <path
        fill='#C04348'
        opacity='1.000000'
        stroke='none'
        d='
  M216.002686,100.005493 
     C210.722183,98.257874 205.441696,96.510262 200.080414,94.114304 
     C200.001129,93.089783 200.002625,92.713593 200.004120,92.337410 
     C208.857407,95.198494 217.729919,98.001709 226.559174,100.935135 
     C237.911011,104.706650 249.229935,108.577393 260.553162,112.434364 
     C260.973846,112.577652 261.290833,113.025467 261.834656,113.976036 
     C262.012970,115.068993 262.012787,115.517265 262.012573,115.965546 
     C261.183716,115.931198 260.278870,116.103859 259.537323,115.831635 
     C247.286026,111.334251 235.065994,106.751480 222.802917,102.286789 
     C221.606567,101.851219 220.173309,102.066399 218.378387,101.657166 
     C217.272064,100.891716 216.637375,100.448601 216.002686,100.005493 
  z'
      />
      <path
        fill='#E6B55A'
        opacity='1.000000'
        stroke='none'
        d='
  M204.517151,81.938065 
     C204.033539,71.447502 203.847717,60.984127 203.910797,50.522251 
     C203.919662,49.052124 205.146759,47.589336 205.809952,46.123154 
     C207.145264,47.694572 209.462204,49.167206 209.632156,50.855904 
     C210.145325,55.955219 209.826752,61.138454 209.828217,66.288979 
     C209.829117,69.445763 210.023026,72.620499 209.742874,75.752518 
     C209.577484,77.601784 208.656006,79.383423 207.997009,81.573364 
     C206.911026,81.956070 205.902588,81.960899 204.517151,81.938065 
  z'
      />
      <path
        fill='#FBEECB'
        opacity='1.000000'
        stroke='none'
        d='
  M84.109383,309.905731 
     C81.094002,307.441711 80.997726,304.114563 84.071075,300.957336 
     C88.927101,295.968750 93.912552,291.106384 98.811462,286.159210 
     C101.059685,283.888824 104.061180,282.517548 105.956009,285.414215 
     C107.353973,287.551300 108.092659,292.113708 106.803032,293.664490 
     C101.630898,299.883972 95.679764,305.489288 89.681183,310.953369 
     C88.732445,311.817566 86.058929,310.788269 84.506264,310.255188 
     C86.502022,309.007782 88.475655,308.458160 89.791779,307.213379 
     C94.221558,303.023621 98.548126,298.704224 102.626953,294.175720 
     C103.935318,292.723114 105.461632,289.201324 104.992958,288.791016 
     C102.450470,286.565094 100.184654,288.393860 98.237465,290.381989 
     C94.544090,294.153076 91.066109,298.169434 87.101265,301.628448 
     C84.373116,304.008484 83.452515,306.546753 84.109383,309.905731 
  z'
      />
      <path
        fill='#C1474D'
        opacity='1.000000'
        stroke='none'
        d='
  M262.371948,116.019135 
     C262.012787,115.517265 262.012970,115.068993 262.016937,114.284195 
     C264.657471,116.053047 268.515045,117.617577 269.727386,120.354050 
     C276.225342,135.020844 282.087097,149.970367 288.109894,164.846008 
     C289.232391,167.618423 290.087128,170.499268 291.000275,173.655502 
     C285.903229,173.981583 288.173615,169.149567 286.565979,166.828232 
     C283.522644,162.433838 281.998566,156.961014 280.001617,151.874115 
     C276.569855,143.132187 273.544983,134.216721 269.760590,125.633690 
     C268.202698,122.100487 265.120270,119.239494 262.371948,116.019135 
  z'
      />
      <path
        fill='#FCEFC7'
        opacity='1.000000'
        stroke='none'
        d='
  M105.920250,230.114777 
     C104.623878,228.069946 102.256676,226.046829 102.214653,223.976547 
     C102.022469,214.508301 101.595436,205.310287 98.393311,196.101105 
     C96.218475,189.846405 97.560295,183.003723 103.912933,178.311279 
     C104.441650,178.430222 104.786285,178.765381 104.588745,179.075562 
     C104.183907,180.891129 103.976608,182.396484 103.381081,184.012177 
     C102.731216,188.288269 101.918465,192.507996 102.320053,196.608810 
     C103.219414,205.792267 104.723083,214.916565 105.983597,224.494308 
     C105.964439,226.654037 105.942345,228.384415 105.920250,230.114777 
  z'
      />
      <path
        fill='#525C67'
        opacity='1.000000'
        stroke='none'
        d='
  M141.553131,71.835739 
     C137.011688,72.028725 132.215073,71.963852 127.418640,71.974068 
     C119.081474,71.991814 113.739655,81.033104 117.433693,88.637360 
     C119.122383,92.113571 120.473282,95.753876 121.964828,99.715263 
     C115.346916,95.190948 113.011253,88.458435 114.022484,80.534615 
     C114.775864,74.631287 118.929680,71.173943 123.998589,69.088928 
     C130.096390,66.580688 135.820221,68.749756 141.553131,71.835739 
  z'
      />
      <path
        fill='#FBECC0'
        opacity='1.000000'
        stroke='none'
        d='
  M119.859245,316.003601 
     C119.445335,316.002899 119.031418,316.002167 118.307007,316.000732 
     C112.183548,309.640900 114.423279,301.795532 114.033470,294.440216 
     C113.937424,292.627991 113.974174,290.808716 113.920921,288.204407 
     C113.280960,286.935211 112.669975,286.454285 112.058990,285.973358 
     C112.058998,285.973358 112.018715,285.981537 112.021370,285.503723 
     C111.990440,280.701782 111.956848,276.377594 111.943352,271.639587 
     C111.988396,270.121033 112.013351,269.016388 112.378212,268.094666 
     C113.789261,274.824036 114.921211,281.361389 115.900093,287.921539 
     C116.265549,290.370667 116.105713,292.898621 116.477013,295.346375 
     C117.523415,302.244415 118.721153,309.119476 119.859245,316.003601 
  z'
      />
      <path
        fill='#C1474D'
        opacity='1.000000'
        stroke='none'
        d='
  M195.378021,329.400391 
     C198.415787,332.212128 209.272125,333.159332 213.958542,331.105682 
     C218.522476,329.105713 223.300171,327.597656 227.960907,325.813263 
     C231.766113,324.356476 235.537247,322.810699 239.703979,321.181732 
     C238.239395,322.558777 236.609100,324.544312 234.511063,325.471832 
     C226.542816,328.994720 218.448395,332.238464 210.352020,335.463196 
     C204.410706,337.829590 196.514435,334.719696 195.378021,329.400391 
  z'
      />
      <path
        fill='#C34A51'
        opacity='1.000000'
        stroke='none'
        d='
  M272.322449,308.921783 
     C272.325165,305.539429 274.440552,304.703033 277.523010,303.862274 
     C282.872070,302.403229 287.948883,299.946106 293.140259,297.908539 
     C294.748596,297.277283 296.331238,296.561584 297.977936,296.054291 
     C298.901672,295.769684 300.420654,296.212616 300.837067,295.677948 
     C303.946198,291.686310 308.699615,292.169708 313.213593,290.978699 
     C311.658478,292.295715 309.866516,293.952118 307.753845,294.871521 
     C297.500854,299.333466 287.171356,303.620636 276.841522,307.903625 
     C275.529999,308.447418 274.057404,308.602814 272.322449,308.921783 
  z'
      />
      <path
        fill='#CC6767'
        opacity='1.000000'
        stroke='none'
        d='
  M169.772552,75.995506 
     C167.126221,70.430382 164.593445,65.149536 162.486954,59.703800 
     C162.105270,58.717060 163.470718,57.054497 164.029602,55.703934 
     C165.256592,56.405594 167.092941,56.811230 167.602997,57.861172 
     C169.599487,61.970940 171.390457,66.214439 172.809586,70.554794 
     C173.412567,72.399002 172.910233,74.604614 172.910233,77.529854 
     C171.907837,77.074768 170.970032,76.649010 169.772552,75.995506 
  z'
      />
      <path
        fill='#FAECC5'
        opacity='1.000000'
        stroke='none'
        d='
  M112.038300,267.911713 
     C112.013351,269.016388 111.988396,270.121033 111.635056,271.615967 
     C110.893845,271.994110 110.481033,271.981934 110.068214,271.969788 
     C110.076080,266.108246 110.220360,260.403625 106.642929,255.037842 
     C105.242302,252.937088 106.091072,249.289825 106.042526,246.344803 
     C105.958366,241.239960 105.973236,236.133499 105.933411,230.571243 
     C105.942345,228.384415 105.964439,226.654037 106.344872,224.627258 
     C107.077820,225.855331 107.655281,227.362762 107.785164,228.907837 
     C108.062737,232.209763 107.898758,235.556076 108.288834,238.839905 
     C109.441322,248.542068 110.775322,258.222656 112.038300,267.911713 
  z'
      />
      <path
        fill='#C86061'
        opacity='1.000000'
        stroke='none'
        d='
  M335.214050,216.930954 
     C336.570648,217.596710 338.005066,217.748749 338.588623,218.533508 
     C339.342102,219.546738 339.833862,221.146469 339.605255,222.333160 
     C339.490570,222.928467 337.299011,223.787796 336.443756,223.467545 
     C331.247131,221.521606 326.007812,219.562698 321.138000,216.946808 
     C319.633850,216.138809 319.240173,213.263565 317.897827,210.393646 
     C324.602753,212.878006 329.758240,214.788239 335.214050,216.930954 
  z'
      />
      <path
        fill='#C86061'
        opacity='1.000000'
        stroke='none'
        d='
  M294.165649,142.238129 
     C293.892151,140.804306 293.458893,138.643555 293.900391,138.446930 
     C300.740723,135.400452 307.694519,132.608719 315.059631,130.675262 
     C310.500092,138.809708 302.396179,140.510620 294.165649,142.238129 
  z'
      />
      <path
        fill='#C96566'
        opacity='1.000000'
        stroke='none'
        d='
  M95.633301,168.271774 
     C97.488884,169.789185 98.975494,171.209732 100.462112,172.630295 
     C100.060951,173.272583 99.659782,173.914871 99.258621,174.557175 
     C96.863792,173.898544 94.412857,173.394028 92.086494,172.547287 
     C87.988533,171.055725 83.874115,169.543198 79.971519,167.622971 
     C78.859810,167.075958 78.456200,165.089874 77.727882,163.763702 
     C79.264122,163.368729 81.045158,162.270996 82.292480,162.705475 
     C86.714890,164.245941 90.955086,166.309540 95.633301,168.271774 
  z'
      />
      <path
        fill='#C86061'
        opacity='1.000000'
        stroke='none'
        d='
  M251.588394,74.853279 
     C249.692841,79.169739 248.100250,83.233391 246.005417,87.019127 
     C245.283997,88.322891 243.310104,88.933617 241.908386,89.860947 
     C241.832489,88.424225 241.297348,86.814568 241.761765,85.581299 
     C243.580139,80.752472 245.596878,75.986954 247.805511,71.323715 
     C248.432922,69.999031 249.960907,69.100906 251.075897,68.007156 
     C251.392471,69.686157 251.749786,71.359154 251.998703,73.048126 
     C252.065948,73.504364 251.804764,74.009010 251.588394,74.853279 
  z'
      />
      <path
        fill='#CC6A6D'
        opacity='1.000000'
        stroke='none'
        d='
  M77.711060,253.747681 
     C82.437767,252.598785 86.791748,251.584351 91.157051,250.567261 
     C90.963875,254.503204 75.710732,261.985962 68.850754,261.394928 
     C69.607368,256.443542 73.262169,254.933670 77.711060,253.747681 
  z'
      />
      <path
        fill='#B6484D'
        opacity='1.000000'
        stroke='none'
        d='
  M199.661072,92.170036 
     C200.002625,92.713593 200.001129,93.089783 199.986694,93.748421 
     C194.926239,92.678619 189.878723,91.326363 184.350464,89.613670 
     C182.578598,88.837952 181.287445,88.422661 179.996292,88.007362 
     C178.442978,88.729660 176.628525,89.174026 175.443130,90.287872 
     C174.821625,90.871872 175.303070,92.629677 175.683136,94.247963 
     C176.704620,95.100914 177.329391,95.563286 178.021362,96.361115 
     C179.035583,98.507393 179.982605,100.318214 180.929611,102.129036 
     C178.160385,99.951904 175.325790,97.851509 172.646423,95.568901 
     C171.036392,94.197281 169.668442,92.541512 168.175323,90.709900 
     C168.976517,90.274391 170.069458,90.435471 170.569519,89.965599 
     C176.200180,84.674850 182.338531,85.479225 188.767441,88.132172 
     C192.227493,89.559998 195.797577,90.721176 199.661072,92.170036 
  z'
      />
      <path
        fill='#FBEEC5'
        opacity='1.000000'
        stroke='none'
        d='
  M122.055878,140.053024 
     C118.889503,144.872375 118.084366,145.038727 114.369431,141.366180 
     C109.546516,136.598282 104.781059,131.772232 99.995506,126.966583 
     C97.296883,124.256622 97.088135,121.306374 99.620148,118.106865 
     C100.067207,118.067429 100.223923,118.225769 100.178535,118.619560 
     C100.858910,121.216652 101.023270,123.901543 102.419754,125.529488 
     C106.050453,129.761963 109.989754,133.812592 114.287086,137.351532 
     C116.133347,138.871964 119.171059,138.945648 121.764465,139.770844 
     C121.861458,139.865051 122.055878,140.053024 122.055878,140.053024 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M114.281494,168.157730 
     C119.859032,161.699173 125.436562,155.240616 131.449158,148.415314 
     C132.568817,148.011353 133.253433,147.974167 133.958923,148.318207 
     C133.212509,150.249130 132.690781,151.996231 131.632843,153.312286 
     C128.161377,157.630753 124.629219,161.917847 120.850349,165.964859 
     C118.792458,168.168762 116.188782,169.863052 113.834557,171.419495 
     C113.985733,170.087128 114.133614,169.122421 114.281494,168.157730 
  z'
      />
      <path
        fill='#B6484D'
        opacity='1.000000'
        stroke='none'
        d='
  M151.984741,122.529846 
     C155.229202,120.836891 156.969589,118.781090 155.320923,114.525658 
     C156.809189,112.679588 158.612854,111.588394 159.895477,110.059952 
     C161.449905,108.207596 162.564026,105.985748 164.275833,103.948929 
     C165.768921,103.984962 166.854874,103.995850 167.940811,104.006737 
     C167.940811,104.006737 167.992676,104.012611 168.032166,104.350327 
     C168.697113,105.131813 169.322586,105.575584 169.948059,106.019363 
     C169.948059,106.019363 169.997223,105.998886 169.990433,106.353943 
     C169.981949,107.150040 169.980240,107.591080 169.978546,108.032127 
     C165.944717,107.560844 163.197586,108.498947 161.539993,112.935188 
     C159.668488,117.943947 156.634323,122.518272 153.689697,127.635223 
     C152.808060,127.978134 152.342499,127.967354 151.876953,127.956573 
     C151.934296,126.285919 151.991638,124.615265 151.984741,122.529846 
  z'
      />
      <path
        fill='#FBEEC5'
        opacity='1.000000'
        stroke='none'
        d='
  M99.989044,117.988052 
     C101.620949,114.703529 104.159248,115.493805 106.024818,117.247627 
     C111.713272,122.595352 117.298737,128.079971 122.514008,133.880219 
     C123.537262,135.018250 122.723564,137.807968 122.406479,139.944458 
     C122.055878,140.053024 121.861458,139.865051 121.788826,139.427490 
     C121.273544,137.838516 121.129303,136.398560 120.340042,135.582306 
     C115.036621,130.097565 109.657143,124.681404 104.137810,119.415443 
     C103.256805,118.574883 101.549316,118.600563 100.223923,118.225769 
     C100.223923,118.225769 100.067207,118.067429 99.989044,117.988052 
  z'
      />
      <path
        fill='#CC4732'
        opacity='1.000000'
        stroke='none'
        d='
  M151.557022,128.052612 
     C152.342499,127.967354 152.808060,127.978134 153.622253,127.985733 
     C150.632828,134.734283 147.406372,141.545319 143.873474,148.193527 
     C143.051788,149.739746 141.187057,150.731705 139.351471,152.008865 
     C138.900696,152.039047 138.738770,152.074265 138.815948,151.727493 
     C138.915848,150.908142 138.938553,150.435577 139.219666,149.820221 
     C139.674667,149.132294 139.871262,148.587173 140.321457,147.879517 
     C140.717575,147.141525 140.860092,146.566040 141.298920,145.803406 
     C143.753677,141.154236 145.912140,136.692200 148.070602,132.230148 
     C149.126099,130.869659 150.181595,129.509155 151.557022,128.052612 
  z'
      />
      <path
        fill='#FCF3D1'
        opacity='1.000000'
        stroke='none'
        d='
  M303.821747,75.961693 
     C301.252319,78.461113 298.670959,80.573105 296.120178,82.721344 
     C292.955597,85.386505 289.816254,88.081642 286.320404,90.827126 
     C289.394562,83.835709 294.543579,78.343941 301.244965,74.352936 
     C301.698090,74.083084 302.945435,75.146828 303.821747,75.961693 
  z'
      />
      <path
        fill='#C34A51'
        opacity='1.000000'
        stroke='none'
        d='
  M330.002075,272.446075 
     C328.963440,268.931122 327.931976,265.859802 326.942322,262.451050 
     C330.327423,264.113281 334.175293,273.386475 333.002625,276.960663 
     C332.313538,279.060944 331.311096,281.058350 330.186188,282.953613 
     C329.938293,281.868286 329.953827,280.931366 329.969330,279.994476 
     C329.982635,277.626221 329.995941,275.257965 330.002075,272.446075 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M147.702271,132.202682 
     C145.912140,136.692200 143.753677,141.154236 141.032242,145.615601 
     C139.597595,145.014069 138.725922,144.413223 137.903656,143.459305 
     C138.695770,141.436981 139.438461,139.767746 140.181168,138.098495 
     C142.565414,136.124069 144.949661,134.149643 147.702271,132.202682 
  z'
      />
      <path
        fill='#FBECC0'
        opacity='1.000000'
        stroke='none'
        d='
  M139.831711,138.117905 
     C139.438461,139.767746 138.695770,141.436981 137.922638,143.469513 
     C137.892212,143.832794 137.885651,143.862228 137.559143,143.903412 
     C136.789169,144.605270 136.345688,145.265945 135.946930,145.958130 
     C135.991669,145.989639 135.925507,145.902466 135.600189,145.947235 
     C134.829453,146.645401 134.384048,147.298813 133.945099,147.961746 
     C133.951569,147.971268 133.938034,147.936981 133.938034,147.936981 
     C133.253433,147.974167 132.568817,148.011353 131.542389,148.061981 
     C131.236801,147.306320 130.957870,146.224106 131.360428,145.818863 
     C133.985306,143.176483 136.757935,140.680908 139.831711,138.117905 
  z'
      />
      <path
        fill='#FCEFC7'
        opacity='1.000000'
        stroke='none'
        d='
  M113.923607,168.153595 
     C114.133614,169.122421 113.985733,170.087128 113.852379,171.431244 
     C113.866913,171.810669 113.860786,171.844620 113.530899,171.877396 
     C112.763855,172.578873 112.326698,173.247574 111.938423,173.951721 
     C111.987312,173.987167 111.914490,173.890839 111.588036,173.937622 
     C110.815201,174.638351 110.368820,175.292313 109.960556,175.968903 
     C109.998680,175.991562 109.941536,175.923676 109.600838,175.984894 
     C107.768852,176.952530 106.277573,177.858948 104.786285,178.765381 
     C104.786285,178.765381 104.441650,178.430222 104.270340,178.264069 
     C107.254593,174.781754 110.410156,171.465622 113.923607,168.153595 
  z'
      />
      <path
        fill='#BE3E41'
        opacity='1.000000'
        stroke='none'
        d='
  M329.637024,280.054596 
     C329.953827,280.931366 329.938293,281.868286 329.940430,283.155609 
     C326.892548,285.284088 323.827057,287.062134 320.384705,288.871948 
     C321.081085,287.799744 322.112610,286.651062 323.236725,285.601593 
     C325.229767,283.740875 327.279022,281.940399 329.637024,280.054596 
  z'
      />
      <path
        fill='#FCF3D1'
        opacity='1.000000'
        stroke='none'
        d='
  M110.046570,272.436584 
     C110.481033,271.981934 110.893845,271.994110 111.614960,272.029846 
     C111.956848,276.377594 111.990440,280.701782 112.027328,285.484070 
     C111.358231,284.695557 110.225021,283.491302 110.105591,282.193756 
     C109.822716,279.120514 110.021103,276.002991 110.046570,272.436584 
  z'
      />
      <path
        fill='#FCF3D1'
        opacity='1.000000'
        stroke='none'
        d='
  M112.083145,286.290405 
     C112.669975,286.454285 113.280960,286.935211 113.909958,287.739899 
     C113.321068,287.578247 112.714180,287.092865 112.083145,286.290405 
  z'
      />
      <path
        fill='#EA4746'
        opacity='1.000000'
        stroke='none'
        d='
  M181.055939,102.411217 
     C179.982605,100.318214 179.035583,98.507393 178.033905,96.022644 
     C177.981079,94.897652 177.982941,94.446571 177.984802,93.995499 
     C181.743530,94.615463 185.502258,95.235428 189.679688,96.245255 
     C190.731949,97.078072 191.365524,97.521027 191.999100,97.963989 
     C199.879654,100.203613 207.772552,102.400917 215.636673,104.696861 
     C221.478088,106.402283 227.311691,108.145737 233.091843,110.045525 
     C236.607452,111.201027 240.003845,112.715096 243.473450,114.015686 
     C248.735321,115.988121 254.014282,117.914963 259.693237,120.247223 
     C260.733398,121.077293 261.366302,121.521324 261.999207,121.965347 
     C264.003174,126.371971 266.007172,130.778610 267.779205,135.845856 
     C265.701447,135.670258 263.855591,134.834061 261.637207,133.913666 
     C260.814697,132.511734 260.453186,131.153641 259.878540,129.892700 
     C259.576660,129.230286 258.972626,128.387177 258.375427,128.266373 
     C257.766144,128.143112 256.596771,128.625671 256.361908,129.151077 
     C254.181992,134.027756 251.999390,138.913620 250.108856,143.907089 
     C246.341507,153.857803 242.925003,163.943420 239.049896,173.850601 
     C235.531448,182.845947 232.019760,191.897842 227.586136,200.448288 
     C226.266541,202.993210 228.051010,208.723389 222.027649,207.684174 
     C220.662033,204.468796 221.377350,200.081451 216.236328,199.712784 
     C212.633667,197.099014 209.238419,194.779877 205.824448,192.031067 
     C202.356827,189.128952 194.656982,189.305359 191.647430,191.940430 
     C185.936646,191.680557 183.068405,194.485916 181.821762,199.534653 
     C181.814621,199.707169 181.501801,199.853409 181.137512,199.906387 
     C177.508698,199.990265 177.939240,202.181534 178.214600,204.243683 
     C178.191284,204.191635 178.302887,204.215118 177.916626,204.200836 
     C176.379837,205.455475 174.178665,206.790726 174.253891,207.982254 
     C174.658951,214.398499 175.409332,220.820618 176.601837,227.134705 
     C176.823975,228.310959 179.605835,229.003799 181.496796,230.084808 
     C183.396774,231.786179 185.006302,233.322479 186.935684,235.057983 
     C189.753082,239.410751 201.755203,242.156601 205.426422,239.310394 
     C205.914078,238.932327 205.816696,237.799667 206.275101,236.873474 
     C207.321701,236.385284 208.083420,236.040054 209.014252,236.030487 
     C211.211151,238.192932 212.443649,239.490250 210.626282,242.891281 
     C207.613480,248.529480 206.019150,254.914749 203.690765,260.932495 
     C201.196899,267.377930 198.764069,273.862610 195.888397,280.139465 
     C193.842865,284.604340 191.115372,288.755554 192.046585,294.313232 
     C192.724991,295.087494 193.358994,295.543640 194.046234,296.326416 
     C194.726517,297.768860 195.353531,298.884705 195.688751,300.042999 
     C195.087143,300.408112 194.777313,300.730743 194.467468,301.053375 
     C194.977707,301.368896 195.487946,301.684448 196.064743,302.352478 
     C197.439468,305.763428 198.461166,308.988831 200.123688,311.840698 
     C202.547791,315.998932 202.771744,321.634125 207.957397,324.321777 
     C206.611023,325.779480 205.298904,326.893066 203.986786,328.006622 
     C202.703934,327.574493 201.421097,327.142334 200.023849,326.038147 
     C199.277817,324.910889 198.646210,324.455719 198.014587,324.000519 
     C196.675079,319.603882 195.335587,315.207245 193.990677,310.060028 
     C193.322968,308.539551 192.660660,307.769653 191.998337,306.999756 
     C191.998337,306.999756 191.993164,306.508392 191.995453,305.846130 
     C191.980515,303.699127 192.080170,302.196564 191.857635,300.743286 
     C191.806824,300.411469 190.643753,300.250000 189.992615,300.010101 
     C189.361160,299.551666 188.729706,299.093231 188.348267,298.275055 
     C188.399277,297.276855 188.200241,296.638428 188.001221,296.000000 
     C184.667694,288.003174 181.730270,279.809326 177.880280,272.069397 
     C174.564178,265.402740 171.763657,258.721680 169.576050,251.552551 
     C167.103485,243.449509 162.523621,236.011536 159.213791,228.135727 
     C155.897491,220.244568 153.138840,212.120453 149.899704,204.194916 
     C148.015762,199.585327 145.518539,195.228897 143.567169,190.643677 
     C141.228531,185.148392 139.129898,179.548279 137.061615,173.944000 
     C136.800232,173.235733 137.174194,172.139297 137.554214,171.371368 
     C142.451111,161.476257 147.449249,151.631073 152.311096,141.718979 
     C153.721832,138.842819 154.360764,135.520203 156.082962,132.877670 
     C160.899887,125.486702 161.390106,115.579483 170.023743,110.055908 
     C171.135162,110.686264 171.593582,111.322014 172.036270,112.342415 
     C172.079697,113.385246 171.880051,114.368217 172.237030,114.652710 
     C177.282867,118.673775 174.334229,122.294289 172.778992,126.939888 
     C171.284012,131.405548 171.666138,137.309937 173.349731,141.781570 
     C174.782623,145.587326 179.016418,148.521301 182.407013,151.369614 
     C189.743408,157.532669 196.153320,157.321701 204.629532,152.650040 
     C219.224808,144.605881 217.454056,133.636597 213.364777,123.023720 
     C212.112091,119.772659 209.081726,115.730507 203.951981,115.636536 
     C201.708374,110.801735 197.582321,112.210854 193.605606,111.992760 
     C192.131592,111.259109 191.034988,110.547707 189.965317,109.797897 
     C188.227356,108.579597 186.507019,107.336136 184.779251,106.103294 
     C183.580261,104.966660 182.381256,103.830025 181.055939,102.411217 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M262.009766,133.997864 
     C263.855591,134.834061 265.701447,135.670258 267.782776,136.242004 
     C269.978607,139.229568 272.376312,142.300278 273.813782,145.768951 
     C277.526459,154.727737 280.747925,163.888580 284.291016,172.919495 
     C288.186951,182.849747 292.139740,192.759583 296.229401,202.611221 
     C298.653717,208.451248 301.569794,214.088913 303.943970,219.947571 
     C307.457916,228.618820 310.441742,237.509933 314.106323,246.113632 
     C317.734894,254.632782 321.927734,262.911621 325.940826,271.646118 
     C327.092010,278.952545 326.596130,280.300354 317.894958,283.910370 
     C308.668182,287.738434 299.033661,290.572693 289.716431,294.198639 
     C285.015747,296.027985 280.740662,298.934845 276.067963,300.855286 
     C263.353302,306.080811 250.509644,310.991455 237.758148,316.128754 
     C232.492691,318.250061 227.320175,320.604736 222.127075,322.902283 
     C217.090424,325.130646 212.112869,327.497528 207.024963,329.599243 
     C206.307755,329.895508 205.111176,329.031372 204.061646,328.355469 
     C205.298904,326.893066 206.611023,325.779480 208.030273,323.972076 
     C214.714371,320.194092 221.274994,317.074402 227.873245,314.036499 
     C233.625458,311.388092 239.347366,308.652740 245.210632,306.270813 
     C258.857758,300.726807 272.593506,295.401459 286.265625,289.918365 
     C289.131470,288.769043 291.814789,287.158966 294.692078,286.044952 
     C302.089172,283.181122 309.620361,280.650513 316.937714,277.601990 
     C319.129578,276.688812 321.067749,274.885345 318.854095,271.671631 
     C316.877106,268.801483 315.463043,265.487396 314.144043,262.230133 
     C308.980957,249.479813 304.046021,236.636703 298.838440,223.904922 
     C296.136749,217.299759 292.766174,210.962234 290.190186,204.313019 
     C286.392517,194.510223 283.399811,184.385956 279.384064,174.680008 
     C275.532318,165.370346 270.656525,156.489456 266.545959,147.279465 
     C264.647064,143.024918 263.498535,138.435471 262.009766,133.997864 
  z'
      />
      <path
        fill='#D64330'
        opacity='1.000000'
        stroke='none'
        d='
  M153.998169,228.001221 
     C162.906448,245.082748 169.165329,263.259979 175.997162,281.948242 
     C175.980194,283.165527 175.965286,283.634003 175.604340,283.994629 
     C174.870026,283.392242 174.344025,282.954346 174.113846,282.394775 
     C169.372971,270.869507 164.662048,259.331940 159.953339,247.793442 
     C157.265518,241.207062 154.592209,234.614746 152.259979,228.018127 
     C153.071121,228.007843 153.534637,228.004532 153.998169,228.001221 
  z'
      />
      <path
        fill='#D2412E'
        opacity='1.000000'
        stroke='none'
        d='
  M139.038193,152.982758 
     C141.320847,157.329498 138.517899,161.386993 136.492264,163.954590 
     C132.673126,168.795578 133.299637,174.003769 134.446350,178.494431 
     C136.336090,185.894913 140.092331,192.810928 142.930695,199.983047 
     C143.568054,201.593552 143.664703,203.418045 143.990845,205.584915 
     C143.971405,206.025803 143.928467,206.065186 143.585571,205.972488 
     C138.888870,196.038986 134.279129,186.298080 130.370575,176.283524 
     C129.452972,173.932434 130.876709,170.652527 131.279694,167.807922 
     C131.460419,166.532227 131.780121,165.276215 132.370667,163.907410 
     C134.815781,160.196625 136.926987,156.589691 139.038193,152.982758 
  z'
      />
      <path
        fill='#D2412E'
        opacity='1.000000'
        stroke='none'
        d='
  M175.950378,284.102509 
     C175.965286,283.634003 175.980194,283.165527 175.999084,282.345367 
     C177.754639,284.758636 179.864639,287.363464 181.185562,290.320770 
     C184.233658,297.144836 186.954178,304.118652 189.633835,311.098450 
     C189.901978,311.796875 188.978775,312.952728 188.250458,313.971405 
     C187.475769,314.009247 187.059097,313.971954 186.351669,313.460693 
     C183.217117,305.511871 180.319077,298.056885 177.564850,290.549164 
     C176.806198,288.481201 176.476761,286.255707 175.950378,284.102509 
  z'
      />
      <path
        fill='#D2412E'
        opacity='1.000000'
        stroke='none'
        d='
  M153.997269,227.603638 
     C153.534637,228.004532 153.071121,228.007843 151.988739,227.773468 
     C149.957703,223.745422 148.481796,219.977219 147.152557,216.157974 
     C145.992035,212.823578 144.996750,209.431671 143.928467,206.065186 
     C143.928467,206.065186 143.971405,206.025803 143.993103,206.006042 
     C146.666183,210.785461 149.449615,215.518417 151.906876,220.415039 
     C152.954453,222.502518 153.320572,224.931992 153.997269,227.603638 
  z'
      />
      <path
        fill='#A14651'
        opacity='1.000000'
        stroke='none'
        d='
  M172.052017,111.957764 
     C171.593582,111.322014 171.135162,110.686264 170.364624,109.984680 
     C170.041809,109.499397 170.031113,109.079964 169.999481,108.346329 
     C169.980240,107.591080 169.981949,107.150040 169.981750,106.379105 
     C173.320618,109.787521 176.661392,113.525826 179.662048,117.641769 
     C178.876282,118.029739 178.430679,118.040062 177.713669,117.844894 
     C175.645523,115.745522 173.848770,113.851639 172.052017,111.957764 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M139.014771,152.735214 
     C136.926987,156.589691 134.815781,160.196625 132.032272,163.895111 
     C130.909409,163.980286 130.458832,163.973877 130.011902,163.589523 
     C132.206161,158.937469 133.368301,153.857803 138.738770,152.074265 
     C138.738770,152.074265 138.900696,152.039047 138.980774,152.017151 
     C139.060837,151.995239 138.991348,152.487671 139.014771,152.735214 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M189.993179,300.418396 
     C190.643753,300.250000 191.806824,300.411469 191.857635,300.743286 
     C192.080170,302.196564 191.980515,303.699127 191.994904,305.600433 
     C191.325958,304.286926 190.659851,302.556824 189.993179,300.418396 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M192.003677,307.352081 
     C192.660660,307.769653 193.322968,308.539551 193.988388,309.663574 
     C193.330673,309.246613 192.669846,308.475494 192.003677,307.352081 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M188.000275,296.333282 
     C188.200241,296.638428 188.399277,297.276855 188.306000,297.957397 
     C188.008926,297.555206 188.004135,297.110870 188.000275,296.333282 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M198.055908,324.318451 
     C198.646210,324.455719 199.277817,324.910889 199.954407,325.683044 
     C199.365341,325.545471 198.731293,325.090912 198.055908,324.318451 
  z'
      />
      <path
        fill='#F1EFF0'
        opacity='1.000000'
        stroke='none'
        d='
  M163.868683,103.923782 
     C162.564026,105.985748 161.449905,108.207596 159.895477,110.059952 
     C158.612854,111.588394 156.809189,112.679588 155.025650,114.257507 
     C151.912323,112.342766 149.058777,110.066833 146.097763,107.940544 
     C138.153824,102.236061 129.751205,97.017494 124.931519,88.021271 
     C123.185188,84.761650 123.129974,81.609650 126.691483,78.628105 
     C130.735550,78.868095 134.315445,79.457878 137.895340,80.047661 
     C140.577301,81.836235 143.388947,83.459900 145.915253,85.446419 
     C151.857574,90.119041 157.663651,94.964920 163.803040,100.310089 
     C164.010376,101.894257 163.939529,102.909019 163.868683,103.923782 
  z'
      />
      <path
        fill='#F6E8E8'
        opacity='1.000000'
        stroke='none'
        d='
  M183.902557,123.750420 
     C185.078735,125.196205 186.289139,126.615761 187.422928,128.094055 
     C189.049728,130.215118 190.391556,132.893036 193.802002,130.794876 
     C197.499161,128.520355 196.445404,125.373482 195.347015,122.261047 
     C194.942764,121.115524 194.313187,120.049530 194.228409,118.521881 
     C203.109344,118.737694 207.154160,124.890953 210.568970,131.374710 
     C211.421967,132.994308 210.902939,136.093491 209.854919,137.800873 
     C207.621826,141.438843 204.628571,144.610214 201.552429,147.970734 
     C196.152725,150.757721 191.162003,149.501877 186.084137,147.576340 
     C184.068771,145.461258 182.141724,143.684448 180.195602,141.445786 
     C180.170471,136.023544 180.164429,131.063171 180.102905,126.085663 
     C180.047440,126.068535 180.121109,126.158287 180.463348,126.083794 
     C181.837906,125.256340 182.870239,124.503380 183.902557,123.750420 
  z'
      />
      <path
        fill='#D33F43'
        opacity='1.000000'
        stroke='none'
        d='
  M180.214691,141.907654 
     C182.141724,143.684448 184.068771,145.461258 185.761414,147.643402 
     C185.211487,148.362457 184.598145,148.925339 184.622574,148.954529 
     C187.814255,152.768646 199.664154,153.249054 203.020569,149.664017 
     C203.134628,149.542175 202.325592,148.556076 201.946823,147.972809 
     C204.628571,144.610214 207.621826,141.438843 209.854919,137.800873 
     C210.902939,136.093491 211.421967,132.994308 210.568970,131.374710 
     C207.154160,124.890953 203.109344,118.737694 194.265015,118.117264 
     C190.868378,114.370087 187.877136,110.602150 184.832581,106.468750 
     C186.507019,107.336136 188.227356,108.579597 189.965317,109.797897 
     C191.034988,110.547707 192.131592,111.259109 193.609253,112.410431 
     C195.058411,113.886497 195.969650,115.571495 197.202332,115.854027 
     C199.373215,116.351608 201.740402,115.992638 204.025406,115.992317 
     C209.081726,115.730507 212.112091,119.772659 213.364777,123.023720 
     C217.454056,133.636597 219.224808,144.605881 204.629532,152.650040 
     C196.153320,157.321701 189.743408,157.532669 182.407013,151.369614 
     C179.016418,148.521301 174.782623,145.587326 173.349731,141.781570 
     C171.666138,137.309937 171.284012,131.405548 172.778992,126.939888 
     C174.334229,122.294289 177.282867,118.673775 172.237030,114.652710 
     C171.880051,114.368217 172.079697,113.385246 172.036270,112.342407 
     C173.848770,113.851639 175.645523,115.745522 177.795380,118.205261 
     C178.806015,121.233513 179.463562,123.695900 180.121109,126.158287 
     C180.121109,126.158287 180.047440,126.068535 179.721313,126.125458 
     C175.523361,131.490799 175.910278,138.915131 180.214691,141.907654 
  z'
      />
      <path
        fill='#3B4656'
        opacity='1.000000'
        stroke='none'
        d='
  M138.210236,79.979820 
     C134.315445,79.457878 130.735550,78.868095 126.747452,78.232895 
     C125.753914,77.951752 125.168587,77.716034 124.583260,77.480309 
     C124.608467,76.966316 124.633675,76.452316 124.658882,75.938316 
     C128.972015,76.191376 133.294907,76.356911 137.583008,76.834595 
     C138.006088,76.881721 138.216202,78.840485 138.210236,79.979820 
  z'
      />
      <path
        fill='#BD4F56'
        opacity='1.000000'
        stroke='none'
        d='
  M180.463348,126.083794 
     C179.463562,123.695900 178.806015,121.233513 178.066772,118.410751 
     C178.430679,118.040062 178.876282,118.029739 179.656036,118.015686 
     C181.317719,119.695358 182.645279,121.378769 183.937683,123.406296 
     C182.870239,124.503380 181.837906,125.256340 180.463348,126.083794 
  z'
      />
      <path
        fill='#A14651'
        opacity='1.000000'
        stroke='none'
        d='
  M164.275833,103.948929 
     C163.939529,102.909019 164.010376,101.894257 164.099884,100.502014 
     C165.374741,101.198830 166.630905,102.273117 167.913940,103.677078 
     C166.854874,103.995850 165.768921,103.984962 164.275833,103.948929 
  z'
      />
      <path
        fill='#A14651'
        opacity='1.000000'
        stroke='none'
        d='
  M169.906204,105.704430 
     C169.322586,105.575584 168.697113,105.131813 168.032379,104.376419 
     C168.616867,104.506371 169.240616,104.947937 169.906204,105.704430 
  z'
      />
      <path
        fill='#D23F43'
        opacity='1.000000'
        stroke='none'
        d='
  M180.070450,88.362244 
     C181.287445,88.422661 182.578598,88.837952 183.950348,89.603882 
     C182.735504,89.542053 181.440048,89.129593 180.070450,88.362244 
  z'
      />
      <path
        fill='#D23F43'
        opacity='1.000000'
        stroke='none'
        d='
  M191.952255,97.651268 
     C191.365524,97.521027 190.731949,97.078072 190.055603,96.318512 
     C190.643677,96.447456 191.274551,96.893005 191.952255,97.651268 
  z'
      />
      <path
        fill='#D23F43'
        opacity='1.000000'
        stroke='none'
        d='
  M177.651886,93.997116 
     C177.982941,94.446571 177.981079,94.897652 177.966675,95.687195 
     C177.329391,95.563286 176.704620,95.100914 176.033051,94.322449 
     C176.430466,94.003807 176.874695,94.001274 177.651886,93.997116 
  z'
      />
      <path
        fill='#D23F43'
        opacity='1.000000'
        stroke='none'
        d='
  M216.048721,100.322311 
     C216.637375,100.448601 217.272064,100.891716 217.957062,101.647018 
     C217.369827,101.519188 216.732285,101.079155 216.048721,100.322311 
  z'
      />
      <path
        fill='#D23F43'
        opacity='1.000000'
        stroke='none'
        d='
  M261.952454,121.652634 
     C261.366302,121.521324 260.733398,121.077293 260.058105,120.316750 
     C260.645691,120.446793 261.275726,120.893349 261.952454,121.652634 
  z'
      />
      <path
        fill='#F2B244'
        opacity='1.000000'
        stroke='none'
        d='
  M138.815948,151.727493 
     C133.368301,153.857803 132.206161,158.937469 129.948761,163.948547 
     C126.167549,170.453217 124.240746,176.248093 127.584991,183.109100 
     C129.619720,187.283554 130.612274,191.980774 131.935440,196.483582 
     C133.621277,202.220535 134.987228,208.056519 136.816284,213.745239 
     C139.733215,222.817429 142.943161,231.795059 145.982224,240.828476 
     C148.352585,247.874237 150.615311,254.956253 152.992691,261.999573 
     C155.264481,268.730133 157.727310,275.397644 159.915771,282.154480 
     C162.545395,290.273438 165.003845,298.448425 167.473755,306.618134 
     C168.409119,309.711975 169.169861,312.858673 170.010193,315.981262 
     C158.153946,317.931946 146.309479,319.958527 134.436295,321.800079 
     C128.823257,322.670685 123.665955,321.762024 119.971619,316.345703 
     C118.721153,309.119476 117.523415,302.244415 116.477013,295.346375 
     C116.105713,292.898621 116.265549,290.370667 115.900093,287.921539 
     C114.921211,281.361389 113.789261,274.824036 112.378220,268.094666 
     C110.775322,258.222656 109.441322,248.542068 108.288834,238.839905 
     C107.898758,235.556076 108.062737,232.209763 107.785164,228.907837 
     C107.655281,227.362762 107.077820,225.855331 106.341934,224.197891 
     C104.723083,214.916565 103.219414,205.792267 102.320053,196.608810 
     C101.918465,192.507996 102.731216,188.288269 103.741692,183.997055 
     C107.241882,181.863113 110.437637,180.159409 109.941536,175.923676 
     C109.941536,175.923676 109.998680,175.991562 110.295319,175.942215 
     C111.032814,175.225525 111.473656,174.558182 111.914490,173.890839 
     C111.914490,173.890839 111.987312,173.987167 112.278671,173.932892 
     C113.000282,173.200623 113.430534,172.522629 113.860786,171.844620 
     C113.860786,171.844620 113.866913,171.810669 113.849091,171.798920 
     C116.188782,169.863052 118.792458,168.168762 120.850349,165.964859 
     C124.629219,161.917847 128.161377,157.630753 131.632843,153.312286 
     C132.690781,151.996231 133.212509,150.249130 133.958923,148.318207 
     C133.938034,147.936981 133.951569,147.971268 134.277374,147.933167 
     C135.043945,147.230865 135.484726,146.566666 135.925507,145.902466 
     C135.925507,145.902466 135.991669,145.989639 136.285080,145.936646 
     C137.014206,145.209854 137.449936,144.536041 137.885651,143.862228 
     C137.885651,143.862228 137.892212,143.832794 137.873230,143.822586 
     C138.725922,144.413223 139.597595,145.014069 140.735962,145.802734 
     C140.860092,146.566040 140.717575,147.141525 140.030121,147.897476 
     C139.310562,148.706299 139.135910,149.334641 138.961273,149.962997 
     C138.938553,150.435577 138.915848,150.908142 138.815948,151.727493 
  z'
      />
      <path
        fill='#EC863A'
        opacity='1.000000'
        stroke='none'
        d='
  M170.431976,316.031921 
     C169.169861,312.858673 168.409119,309.711975 167.473755,306.618134 
     C165.003845,298.448425 162.545395,290.273438 159.915771,282.154480 
     C157.727310,275.397644 155.264481,268.730133 152.992691,261.999573 
     C150.615311,254.956253 148.352585,247.874237 145.982224,240.828476 
     C142.943161,231.795059 139.733215,222.817429 136.816284,213.745239 
     C134.987228,208.056519 133.621277,202.220535 131.935440,196.483582 
     C130.612274,191.980774 129.619720,187.283554 127.584991,183.109100 
     C124.240746,176.248093 126.167549,170.453217 129.945129,164.326477 
     C130.458832,163.973877 130.909409,163.980286 131.698364,163.998993 
     C131.780121,165.276215 131.460419,166.532227 131.279694,167.807922 
     C130.876709,170.652527 129.452972,173.932434 130.370575,176.283524 
     C134.279129,186.298080 138.888870,196.038986 143.585571,205.972488 
     C144.996750,209.431671 145.992035,212.823578 147.152557,216.157974 
     C148.481796,219.977219 149.957703,223.745422 151.641129,227.780457 
     C154.592209,234.614746 157.265518,241.207062 159.953339,247.793442 
     C164.662048,259.331940 169.372971,270.869507 174.113846,282.394775 
     C174.344025,282.954346 174.870026,283.392242 175.604340,283.994629 
     C176.476761,286.255707 176.806198,288.481201 177.564850,290.549164 
     C180.319077,298.056885 183.217117,305.511871 186.046417,313.388000 
     C180.972534,314.553711 175.913147,315.318146 170.431976,316.031921 
  z'
      />
      <path
        fill='#E4B254'
        opacity='1.000000'
        stroke='none'
        d='
  M84.056061,309.951904 
     C83.452515,306.546753 84.373116,304.008484 87.101265,301.628448 
     C91.066109,298.169434 94.544090,294.153076 98.237465,290.381989 
     C100.184654,288.393860 102.450470,286.565094 104.992958,288.791016 
     C105.461632,289.201324 103.935318,292.723114 102.626953,294.175720 
     C98.548126,298.704224 94.221558,303.023621 89.791779,307.213379 
     C88.475655,308.458160 86.502022,309.007782 84.461227,309.882874 
     C84.092781,309.889832 84.002747,309.998047 84.056061,309.951904 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M109.600838,175.984894 
     C110.437637,180.159409 107.241882,181.863113 104.129921,183.886734 
     C103.976608,182.396484 104.183907,180.891129 104.588745,179.075562 
     C106.277573,177.858948 107.768852,176.952530 109.600838,175.984894 
  z'
      />
      <path
        fill='#E2B24F'
        opacity='1.000000'
        stroke='none'
        d='
  M100.178535,118.619560 
     C101.549316,118.600563 103.256805,118.574883 104.137810,119.415443 
     C109.657143,124.681404 115.036621,130.097565 120.340042,135.582306 
     C121.129303,136.398560 121.273544,137.838516 121.691833,139.333282 
     C119.171059,138.945648 116.133347,138.871964 114.287086,137.351532 
     C109.989754,133.812592 106.050453,129.761963 102.419754,125.529488 
     C101.023270,123.901543 100.858910,121.216652 100.178535,118.619560 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M139.219666,149.820221 
     C139.135910,149.334641 139.310562,148.706299 139.776535,148.059998 
     C139.871262,148.587173 139.674667,149.132294 139.219666,149.820221 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M137.559143,143.903412 
     C137.449936,144.536041 137.014206,145.209854 136.240356,145.905136 
     C136.345688,145.265945 136.789169,144.605270 137.559143,143.903412 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M135.600189,145.947235 
     C135.484726,146.566666 135.043945,147.230865 134.270905,147.923645 
     C134.384048,147.298813 134.829453,146.645401 135.600189,145.947235 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M113.530899,171.877396 
     C113.430534,172.522629 113.000282,173.200623 112.229782,173.897461 
     C112.326698,173.247574 112.763855,172.578873 113.530899,171.877396 
  z'
      />
      <path
        fill='#ECAF58'
        opacity='1.000000'
        stroke='none'
        d='
  M111.588043,173.937622 
     C111.473656,174.558182 111.032814,175.225525 110.257202,175.919556 
     C110.368820,175.292313 110.815201,174.638351 111.588043,173.937622 
  z'
      />
      <path
        fill='#D9393D'
        opacity='1.000000'
        stroke='none'
        d='
  M261.637207,133.913666 
     C263.498535,138.435471 264.647064,143.024918 266.545959,147.279465 
     C270.656525,156.489456 275.532318,165.370346 279.384064,174.680008 
     C283.399811,184.385956 286.392517,194.510223 290.190186,204.313019 
     C292.766174,210.962234 296.136749,217.299759 298.838440,223.904922 
     C304.046021,236.636703 308.980957,249.479813 314.144043,262.230133 
     C315.463043,265.487396 316.877106,268.801483 318.854095,271.671631 
     C321.067749,274.885345 319.129578,276.688812 316.937714,277.601990 
     C309.620361,280.650513 302.089172,283.181122 294.692078,286.044952 
     C291.814789,287.158966 289.131470,288.769043 286.265625,289.918365 
     C272.593506,295.401459 258.857758,300.726807 245.210632,306.270813 
     C239.347366,308.652740 233.625458,311.388092 227.873245,314.036499 
     C221.274994,317.074402 214.714371,320.194092 208.064529,323.627930 
     C202.771744,321.634125 202.547791,315.998932 200.123688,311.840698 
     C198.461166,308.988831 197.439468,305.763428 196.065399,302.019226 
     C195.993179,300.889130 195.986862,300.444855 195.980545,300.000549 
     C195.353531,298.884705 194.726517,297.768860 194.003052,296.008362 
     C193.271805,294.907501 192.636993,294.451324 192.002167,293.995117 
     C191.115372,288.755554 193.842865,284.604340 195.888397,280.139465 
     C198.764069,273.862610 201.196899,267.377930 203.690765,260.932495 
     C206.019150,254.914749 207.613480,248.529480 210.626282,242.891281 
     C212.443649,239.490250 211.211151,238.192932 209.274567,235.766144 
     C211.592834,234.109909 213.819916,233.053696 216.449677,231.997925 
     C221.023819,231.966919 220.343018,234.802673 219.544373,237.120560 
     C218.714386,239.529373 217.247803,241.718842 215.992798,244.372742 
     C212.009155,254.333466 207.894043,263.853241 204.342590,273.578857 
     C203.631638,275.525818 202.002548,279.546387 206.974335,279.987915 
     C207.031708,279.938660 207.182419,279.926117 207.129700,280.273682 
     C208.055481,282.114929 209.033981,283.608612 210.028900,285.504944 
     C211.912018,290.092773 216.230713,288.568054 218.044159,287.583496 
     C221.212433,285.863342 223.843597,282.576141 225.813416,279.396484 
     C227.610275,276.496002 228.265152,272.878326 229.357773,269.555206 
     C229.957260,267.731903 230.421265,265.864105 230.983002,263.618835 
     C231.102798,262.567566 231.058228,261.864563 231.288696,261.267731 
     C233.789261,254.791733 236.332993,248.332397 238.899963,241.876526 
     C238.934998,241.884537 238.891754,241.941910 239.288452,241.938843 
     C241.123123,239.290268 242.561127,236.644791 244.356659,234.070679 
     C244.744202,235.520050 245.202377,237.070786 244.728470,238.245483 
     C242.897095,242.784897 244.511581,252.464935 248.018463,256.290070 
     C249.633102,258.341492 251.235382,260.004089 252.695526,261.783264 
     C259.150757,269.649017 268.048340,268.735565 276.449158,267.571930 
     C279.970947,267.084106 284.574066,265.127258 285.087616,259.594360 
     C286.392548,258.176422 287.594513,257.053009 289.194580,255.936798 
     C294.580048,252.840469 296.142944,240.104492 292.025513,235.611389 
     C289.630371,227.909683 285.808289,221.789734 277.724823,220.006790 
     C274.002808,219.185837 270.086151,219.217987 266.252106,218.941528 
     C261.167633,218.574921 256.683502,219.806808 253.182617,223.824570 
     C251.659454,225.572647 249.959747,227.190979 248.171127,228.662781 
     C247.825531,228.947159 246.694229,228.276703 245.958176,227.661499 
     C247.340408,223.508255 248.689865,219.740204 250.387115,215.908340 
     C254.213699,214.197083 254.230835,211.160492 253.924866,207.648392 
     C253.978851,206.871368 253.998627,206.426468 254.332062,205.936707 
     C255.065826,205.257278 255.485916,204.622726 255.929230,203.651093 
     C255.976715,202.864182 256.000977,202.414352 256.374390,201.900696 
     C257.131561,200.572525 257.539551,199.308136 258.230957,197.817184 
     C260.002228,193.087585 261.490051,188.584549 263.017456,183.642487 
     C263.052704,181.728485 263.204559,180.233200 263.015930,178.782196 
     C262.335724,173.549789 258.208038,171.430557 253.975052,170.478485 
     C252.331848,170.108871 250.012070,172.747269 247.713684,174.165909 
     C246.604187,175.541763 245.781479,176.767136 244.568451,178.018494 
     C243.243073,179.898865 242.153717,181.692780 241.399414,183.617966 
     C237.922775,192.491486 234.539490,201.401581 231.169418,210.589478 
     C231.129715,211.257767 231.043320,211.635117 230.577118,212.029022 
     C228.800949,214.406387 227.429108,216.782196 225.998566,219.122131 
     C225.201843,220.425354 224.307434,221.668839 223.457031,222.939240 
     C223.044342,222.679123 222.631653,222.418991 222.218948,222.158875 
     C222.321579,217.462143 225.861557,212.672089 222.053284,208.081558 
     C228.051010,208.723389 226.266541,202.993210 227.586136,200.448288 
     C232.019760,191.897842 235.531448,182.845947 239.049896,173.850601 
     C242.925003,163.943420 246.341507,153.857803 250.108856,143.907089 
     C251.999390,138.913620 254.181992,134.027756 256.361908,129.151077 
     C256.596771,128.625671 257.766144,128.143112 258.375427,128.266373 
     C258.972626,128.387177 259.576660,129.230286 259.878540,129.892700 
     C260.453186,131.153641 260.814697,132.511734 261.637207,133.913666 
  z'
      />
      <path
        fill='#FCF2F4'
        opacity='1.000000'
        stroke='none'
        d='
  M216.046997,231.997467 
     C213.819916,233.053696 211.592834,234.109909 209.105438,235.430481 
     C208.083420,236.040054 207.321701,236.385284 205.856934,236.824463 
     C204.396210,236.651199 203.657928,236.255905 202.877640,236.137711 
     C198.000061,235.398926 193.116898,234.692184 188.223465,234.070358 
     C187.728973,234.007507 187.153656,234.580765 186.615845,234.858795 
     C185.006302,233.322479 183.396774,231.786179 181.366455,229.721680 
     C177.204102,221.170029 175.495148,212.931519 178.302887,204.215118 
     C178.302887,204.215118 178.191284,204.191635 178.565567,204.214157 
     C179.793839,202.775589 180.647827,201.314499 181.501801,199.853424 
     C181.501801,199.853409 181.814621,199.707169 182.153290,199.622253 
     C186.396652,197.060089 190.301376,194.582840 194.647018,192.165070 
     C198.673019,192.303299 202.258102,192.382019 205.843170,192.460754 
     C209.238419,194.779877 212.633667,197.099014 216.156281,200.066132 
     C219.959610,205.061188 221.211197,210.282227 220.328018,215.647034 
     C219.416824,221.182083 217.515274,226.554123 216.046997,231.997467 
  M204.062668,211.135590 
     C199.412369,206.614044 196.983322,206.799149 193.174118,212.100525 
     C193.570297,214.389908 193.251968,217.247299 194.520599,218.843109 
     C196.738342,221.632858 200.678207,221.791748 202.918060,219.342819 
     C204.268402,217.866470 208.411972,215.037048 204.062668,211.135590 
  z'
      />
      <path
        fill='#C6454C'
        opacity='1.000000'
        stroke='none'
        d='
  M216.449661,231.997925 
     C217.515274,226.554123 219.416824,221.182083 220.328018,215.647034 
     C221.211197,210.282227 219.959610,205.061188 216.363708,200.360779 
     C221.377350,200.081451 220.662033,204.468796 222.027649,207.684174 
     C225.861557,212.672089 222.321579,217.462143 222.218948,222.158875 
     C222.631653,222.418991 223.044342,222.679123 223.457031,222.939240 
     C224.307434,221.668839 225.201843,220.425354 225.998566,219.122131 
     C227.429108,216.782196 228.800949,214.406387 230.626755,212.440262 
     C230.465164,215.191452 230.115936,217.642319 229.239609,219.887451 
     C226.087967,227.961868 222.758392,235.966843 219.152222,243.998688 
     C217.892120,244.000961 216.975861,244.002594 216.059601,244.004211 
     C217.247803,241.718842 218.714386,239.529373 219.544373,237.120560 
     C220.343018,234.802673 221.023819,231.966919 216.449661,231.997925 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M177.916626,204.200836 
     C175.495148,212.931519 177.204102,221.170029 181.076019,229.556625 
     C179.605835,229.003799 176.823975,228.310959 176.601837,227.134705 
     C175.409332,220.820618 174.658951,214.398499 174.253891,207.982254 
     C174.178665,206.790726 176.379837,205.455475 177.916626,204.200836 
  z'
      />
      <path
        fill='#A54346'
        opacity='1.000000'
        stroke='none'
        d='
  M186.935699,235.057983 
     C187.153656,234.580765 187.728973,234.007507 188.223465,234.070358 
     C193.116898,234.692184 198.000061,235.398926 202.877640,236.137711 
     C203.657928,236.255905 204.396210,236.651199 205.572067,236.967438 
     C205.816696,237.799667 205.914078,238.932327 205.426422,239.310394 
     C201.755203,242.156601 189.753082,239.410751 186.935699,235.057983 
  z'
      />
      <path
        fill='#D9393D'
        opacity='1.000000'
        stroke='none'
        d='
  M203.951981,115.636536 
     C201.740402,115.992638 199.373215,116.351608 197.202332,115.854027 
     C195.969650,115.571495 195.058411,113.886497 193.998764,112.415436 
     C197.582321,112.210854 201.708374,110.801735 203.951981,115.636536 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M194.206085,192.105591 
     C190.301376,194.582840 186.396652,197.060089 182.160431,199.449738 
     C183.068405,194.485916 185.936646,191.680557 192.004379,191.970078 
     C193.251434,192.018951 193.728760,192.062271 194.206085,192.105591 
  z'
      />
      <path
        fill='#C6454C'
        opacity='1.000000'
        stroke='none'
        d='
  M194.647018,192.165070 
     C193.728760,192.062271 193.251434,192.018951 192.417160,191.945953 
     C194.656982,189.305359 202.356827,189.128952 205.824448,192.031067 
     C202.258102,192.382019 198.673019,192.303299 194.647018,192.165070 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M181.137512,199.906403 
     C180.647827,201.314499 179.793839,202.775589 178.588898,204.266205 
     C177.939240,202.181534 177.508698,199.990265 181.137512,199.906403 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M192.046585,294.313232 
     C192.636993,294.451324 193.271805,294.907501 193.949814,295.681763 
     C193.358994,295.543640 192.724991,295.087494 192.046585,294.313232 
  z'
      />
      <path
        fill='#E94647'
        opacity='1.000000'
        stroke='none'
        d='
  M195.688751,300.042999 
     C195.986862,300.444855 195.993179,300.889130 195.998840,301.666718 
     C195.487946,301.684448 194.977707,301.368896 194.467468,301.053375 
     C194.777313,300.730743 195.087143,300.408112 195.688751,300.042999 
  z'
      />
      <path
        fill='#BE3E41'
        opacity='1.000000'
        stroke='none'
        d='
  M201.552429,147.970734 
     C202.325592,148.556076 203.134628,149.542175 203.020569,149.664017 
     C199.664154,153.249054 187.814255,152.768646 184.622574,148.954529 
     C184.598145,148.925339 185.211487,148.362457 185.849762,147.981689 
     C191.162003,149.501877 196.152725,150.757721 201.552429,147.970734 
  z'
      />
      <path
        fill='#BD4F56'
        opacity='1.000000'
        stroke='none'
        d='
  M180.195602,141.445786 
     C175.910278,138.915131 175.523361,131.490799 179.776779,126.142586 
     C180.164429,131.063171 180.170471,136.023544 180.195602,141.445786 
  z'
      />
      <path
        fill='#FDF3F5'
        opacity='1.000000'
        stroke='none'
        d='
  M219.496063,243.998047 
     C222.758392,235.966843 226.087967,227.961868 229.239609,219.887451 
     C230.115936,217.642319 230.465164,215.191452 231.006561,212.423721 
     C231.043320,211.635117 231.129715,211.257767 231.553619,210.521149 
     C232.462357,209.918243 233.376831,209.821564 233.553482,209.408997 
     C236.340607,202.899582 239.199768,196.412079 241.682480,189.784714 
     C243.108185,185.978943 243.888138,181.931274 244.958786,177.992493 
     C245.781479,176.767136 246.604187,175.541763 248.160934,174.248962 
     C259.245300,173.136719 260.418335,174.152069 260.190247,184.430634 
     C258.649353,189.130508 257.224701,193.458862 255.439972,197.886520 
     C253.969345,201.291122 252.858826,204.596420 251.397522,207.960480 
     C250.150024,210.024490 249.253311,212.029724 248.216568,214.400696 
     C246.633347,219.121643 245.190155,223.476868 243.801514,227.839630 
     C243.856079,227.847183 243.817093,227.744156 243.461609,227.827515 
     C242.705399,229.217575 242.304672,230.524277 241.564087,231.969208 
     C240.451920,235.386810 236.439651,237.897781 238.891754,241.941910 
     C238.891754,241.941910 238.934998,241.884537 238.522369,241.931305 
     C237.633804,242.090881 236.833847,242.073898 236.729095,242.335388 
     C233.837906,249.553452 231.017365,256.799835 228.074142,264.337189 
     C227.955917,265.053528 227.948669,265.474213 227.672974,266.035706 
     C227.059921,266.807526 226.715317,267.438446 226.240143,268.436523 
     C224.643494,272.518524 223.177429,276.233368 221.413651,279.983398 
     C220.720215,280.631927 220.324478,281.245239 219.935287,281.899048 
     C219.941833,281.939545 219.860321,281.930573 219.563705,281.959778 
     C218.827194,282.556580 218.387299,283.124146 217.538498,283.816254 
     C215.426712,283.906311 213.723846,283.871826 211.962418,283.509888 
     C210.330063,282.096985 208.756241,281.011566 207.182419,279.926117 
     C207.182419,279.926117 207.031708,279.938660 207.044983,279.716980 
     C207.102402,279.313934 207.146561,279.132538 207.435730,278.750275 
     C207.558655,277.371735 207.436554,276.194122 207.210205,274.685852 
     C207.382828,273.560242 207.659714,272.765259 208.292740,271.927612 
     C209.033890,271.126617 209.418915,270.368347 209.775513,269.229950 
     C212.996750,260.565918 216.246414,252.281982 219.496063,243.998047 
  z'
      />
      <path
        fill='#FDF4F5'
        opacity='1.000000'
        stroke='none'
        d='
  M288.796478,255.929565 
     C287.594513,257.053009 286.392548,258.176422 284.699768,259.661926 
     C283.877625,260.047455 283.472382,259.954407 283.225494,260.111053 
     C272.173126,267.123718 258.016144,268.018768 249.850983,253.611740 
     C249.137390,249.124191 248.073532,245.054718 247.791046,240.931702 
     C247.091095,230.714828 256.563599,223.352997 262.259125,222.102890 
     C274.121124,219.499268 283.832306,223.436554 288.175537,232.372711 
     C289.692413,235.493652 290.698975,238.862610 291.873047,242.511856 
     C290.803802,247.246796 289.800140,251.588181 288.796478,255.929565 
  M264.566132,240.439957 
     C261.156250,242.678757 263.217468,245.649139 264.608795,247.193497 
     C266.221222,248.983276 268.723541,251.108765 271.935577,248.424667 
     C274.502258,246.279846 277.113281,244.127579 275.156219,240.844238 
     C274.052612,238.992783 271.260345,237.738678 268.990570,237.175613 
     C267.958221,236.919479 266.348419,238.991028 265.000549,239.999985 
     C265.000549,239.999985 265.003937,239.992157 264.566132,240.439957 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M291.938599,242.118301 
     C290.698975,238.862610 289.692413,235.493652 288.175537,232.372711 
     C283.832306,223.436554 274.121124,219.499268 262.259125,222.102890 
     C256.563599,223.352997 247.091095,230.714828 247.791046,240.931702 
     C248.073532,245.054718 249.137390,249.124191 249.546143,253.661514 
     C248.811310,254.721634 248.375992,255.338257 247.940674,255.954880 
     C244.511581,252.464935 242.897095,242.784897 244.728470,238.245483 
     C245.202377,237.070786 244.744202,235.520050 244.348755,234.062057 
     C243.983307,233.982071 243.967148,233.964783 243.982971,233.525269 
     C243.938232,231.305206 243.877670,229.524689 243.817093,227.744156 
     C243.817093,227.744156 243.856079,227.847183 244.162842,227.902435 
     C244.954880,227.987366 245.440125,228.017029 245.925385,228.046692 
     C246.694229,228.276703 247.825531,228.947159 248.171127,228.662781 
     C249.959747,227.190979 251.659454,225.572647 253.182617,223.824570 
     C256.683502,219.806808 261.167633,218.574921 266.252106,218.941528 
     C270.086151,219.217987 274.002808,219.185837 277.724823,220.006790 
     C285.808289,221.789734 289.630371,227.909683 292.028259,236.047989 
     C292.010132,238.619904 291.974365,240.369110 291.938599,242.118301 
  z'
      />
      <path
        fill='#A23A40'
        opacity='1.000000'
        stroke='none'
        d='
  M248.018463,256.290070 
     C248.375992,255.338257 248.811310,254.721634 249.551483,254.055222 
     C258.016144,268.018768 272.173126,267.123718 283.225494,260.111053 
     C283.472382,259.954407 283.877625,260.047455 284.596863,259.956482 
     C284.574066,265.127258 279.970947,267.084106 276.449158,267.571930 
     C268.048340,268.735565 259.150757,269.649017 252.695526,261.783264 
     C251.235382,260.004089 249.633102,258.341492 248.018463,256.290070 
  z'
      />
      <path
        fill='#C1474D'
        opacity='1.000000'
        stroke='none'
        d='
  M207.190704,278.951172 
     C207.146561,279.132538 207.102402,279.313934 206.987610,279.766235 
     C202.002548,279.546387 203.631638,275.525818 204.342590,273.578857 
     C207.894043,263.853241 212.009155,254.333466 215.992798,244.372742 
     C216.975861,244.002594 217.892120,244.000961 219.152237,243.998688 
     C216.246414,252.281982 212.996750,260.565918 209.431274,269.282288 
     C208.722488,270.466583 208.329559,271.218445 207.936615,271.970276 
     C207.659714,272.765259 207.382828,273.560242 207.099426,275.001465 
     C207.125488,276.748840 207.158096,277.850006 207.190704,278.951172 
  z'
      />
      <path
        fill='#AD3E44'
        opacity='1.000000'
        stroke='none'
        d='
  M227.941406,265.894867 
     C227.948669,265.474213 227.955917,265.053528 228.419907,264.340393 
     C229.566544,264.037384 230.256439,264.026855 230.946335,264.016357 
     C230.421265,265.864105 229.957260,267.731903 229.357773,269.555206 
     C228.265152,272.878326 227.610275,276.496002 225.813416,279.396484 
     C223.843597,282.576141 221.212433,285.863342 218.044159,287.583496 
     C216.230713,288.568054 211.912018,290.092773 210.299377,285.378235 
     C211.042603,284.511658 211.531784,284.174500 212.020966,283.837341 
     C213.723846,283.871826 215.426712,283.906311 217.851334,283.817230 
     C219.002151,283.105957 219.431229,282.518280 219.860321,281.930573 
     C219.860321,281.930573 219.941833,281.939545 220.239136,281.834717 
     C220.928085,281.135986 221.319717,280.542114 221.711365,279.948212 
     C223.177429,276.233368 224.643494,272.518524 226.554443,268.395935 
     C227.313354,267.290405 227.627380,266.592651 227.941406,265.894867 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M244.568451,178.018494 
     C243.888138,181.931274 243.108185,185.978943 241.682480,189.784714 
     C239.199768,196.412079 236.340607,202.899582 233.553482,209.408997 
     C233.376831,209.821564 232.462357,209.918243 231.506927,210.230225 
     C234.539490,201.401581 237.922775,192.491486 241.399414,183.617966 
     C242.153717,181.692780 243.243073,179.898865 244.568451,178.018494 
  z'
      />
      <path
        fill='#BB5B65'
        opacity='1.000000'
        stroke='none'
        d='
  M230.983002,263.618805 
     C230.256439,264.026855 229.566544,264.037384 228.530884,264.044708 
     C231.017365,256.799835 233.837906,249.553452 236.729095,242.335388 
     C236.833847,242.073898 237.633804,242.090881 238.487350,241.923309 
     C236.332993,248.332397 233.789261,254.791733 231.288696,261.267731 
     C231.058228,261.864563 231.102798,262.567566 230.983002,263.618805 
  z'
      />
      <path
        fill='#CC6A6D'
        opacity='1.000000'
        stroke='none'
        d='
  M260.306458,184.059113 
     C260.418335,174.152069 259.245300,173.136719 248.447723,174.098450 
     C250.012070,172.747269 252.331848,170.108871 253.975052,170.478485 
     C258.208038,171.430557 262.335724,173.549789 263.015930,178.782196 
     C263.204559,180.233200 263.052704,181.728485 262.684052,183.644287 
     C261.642853,184.076447 260.974640,184.067780 260.306458,184.059113 
  z'
      />
      <path
        fill='#BB333A'
        opacity='1.000000'
        stroke='none'
        d='
  M291.873047,242.511856 
     C291.974365,240.369110 292.010132,238.619904 292.043152,236.434113 
     C296.142944,240.104492 294.580048,252.840469 289.194580,255.936798 
     C289.800140,251.588181 290.803802,247.246796 291.873047,242.511856 
  z'
      />
      <path
        fill='#BD4F56'
        opacity='1.000000'
        stroke='none'
        d='
  M260.190247,184.430634 
     C260.974640,184.067780 261.642853,184.076447 262.644470,184.083313 
     C261.490051,188.584549 260.002228,193.087585 257.916626,197.801041 
     C256.898621,198.026779 256.478394,198.042099 255.993347,197.990143 
     C255.928513,197.922897 255.800049,197.787216 255.800049,197.787216 
     C257.224701,193.458862 258.649353,189.130508 260.190247,184.430634 
  z'
      />
      <path
        fill='#AE444A'
        opacity='1.000000'
        stroke='none'
        d='
  M245.958176,227.661499 
     C245.440125,228.017029 244.954880,227.987366 244.108292,227.894897 
     C245.190155,223.476868 246.633347,219.121643 248.494934,214.467041 
     C249.288666,214.769135 249.663986,215.370651 250.039322,215.972153 
     C248.689865,219.740204 247.340408,223.508255 245.958176,227.661499 
  z'
      />
      <path
        fill='#C84A51'
        opacity='1.000000'
        stroke='none'
        d='
  M239.288452,241.938843 
     C236.439651,237.897781 240.451920,235.386810 241.632126,232.298904 
     C242.682404,232.981857 243.324768,233.473328 243.967148,233.964783 
     C243.967148,233.964783 243.983307,233.982071 243.991211,233.990692 
     C242.561127,236.644791 241.123123,239.290268 239.288452,241.938843 
  z'
      />
      <path
        fill='#C34A51'
        opacity='1.000000'
        stroke='none'
        d='
  M250.387115,215.908340 
     C249.663986,215.370651 249.288666,214.769135 248.634964,214.101303 
     C249.253311,212.029724 250.150024,210.024490 251.754898,207.983582 
     C252.938934,207.958801 253.414795,207.969666 253.890671,207.980530 
     C254.230835,211.160492 254.213699,214.197083 250.387115,215.908340 
  z'
      />
      <path
        fill='#BD4F56'
        opacity='1.000000'
        stroke='none'
        d='
  M253.924866,207.648392 
     C253.414795,207.969666 252.938934,207.958801 252.105682,207.924805 
     C252.858826,204.596420 253.969345,201.291122 255.439972,197.886520 
     C255.800049,197.787216 255.928513,197.922897 255.974609,198.380173 
     C256.022186,199.879807 256.023712,200.922150 256.025238,201.964508 
     C256.000977,202.414352 255.976715,202.864182 255.624084,203.702179 
     C254.869965,204.720734 254.444183,205.351166 254.018417,205.981583 
     C253.998627,206.426468 253.978851,206.871368 253.924866,207.648392 
  z'
      />
      <path
        fill='#F8D5DC'
        opacity='1.000000'
        stroke='none'
        d='
  M211.962418,283.509888 
     C211.531784,284.174500 211.042603,284.511658 210.282959,284.975525 
     C209.033981,283.608612 208.055481,282.114929 207.129700,280.273682 
     C208.756241,281.011566 210.330063,282.096985 211.962418,283.509888 
  z'
      />
      <path
        fill='#C34A51'
        opacity='1.000000'
        stroke='none'
        d='
  M256.374390,201.900696 
     C256.023712,200.922150 256.022186,199.879807 256.039429,198.447418 
     C256.478394,198.042099 256.898621,198.026779 257.633179,198.027603 
     C257.539551,199.308136 257.131561,200.572525 256.374390,201.900696 
  z'
      />
      <path
        fill='#C34A51'
        opacity='1.000000'
        stroke='none'
        d='
  M254.332062,205.936707 
     C254.444183,205.351166 254.869965,204.720734 255.600876,204.039246 
     C255.485916,204.622726 255.065826,205.257278 254.332062,205.936707 
  z'
      />
      <path
        fill='#D25E60'
        opacity='1.000000'
        stroke='none'
        d='
  M204.120071,211.894348 
     C208.411972,215.037048 204.268402,217.866470 202.918060,219.342819 
     C200.678207,221.791748 196.738342,221.632858 194.520599,218.843109 
     C193.251968,217.247299 193.570297,214.389908 193.609940,212.329315 
     C197.311768,212.647186 200.577667,212.743561 203.844269,212.785980 
     C203.932327,212.787125 204.027969,212.204666 204.120071,211.894348 
  z'
      />
      <path
        fill='#A54346'
        opacity='1.000000'
        stroke='none'
        d='
  M204.091370,211.514969 
     C204.027969,212.204666 203.932327,212.787125 203.844269,212.785980 
     C200.577667,212.743561 197.311768,212.647186 193.955154,212.235428 
     C196.983322,206.799149 199.412369,206.614044 204.091370,211.514969 
  z'
      />
      <path
        fill='#AE444A'
        opacity='1.000000'
        stroke='none'
        d='
  M243.982971,233.525269 
     C243.324768,233.473328 242.682404,232.981857 241.971985,232.160675 
     C242.304672,230.524277 242.705399,229.217575 243.461609,227.827515 
     C243.877670,229.524689 243.938232,231.305206 243.982971,233.525269 
  z'
      />
      <path
        fill='#F8D5DC'
        opacity='1.000000'
        stroke='none'
        d='
  M207.435730,278.750275 
     C207.158096,277.850006 207.125488,276.748840 207.203674,275.332092 
     C207.436554,276.194122 207.558655,277.371735 207.435730,278.750275 
  z'
      />
      <path
        fill='#F8D5DC'
        opacity='1.000000'
        stroke='none'
        d='
  M219.563705,281.959778 
     C219.431229,282.518280 219.002151,283.105957 218.260239,283.692688 
     C218.387299,283.124146 218.827194,282.556580 219.563705,281.959778 
  z'
      />
      <path
        fill='#F8D5DC'
        opacity='1.000000'
        stroke='none'
        d='
  M221.413635,279.983398 
     C221.319717,280.542114 220.928085,281.135986 220.232590,281.794250 
     C220.324478,281.245239 220.720215,280.631927 221.413635,279.983398 
  z'
      />
      <path
        fill='#F8D5DC'
        opacity='1.000000'
        stroke='none'
        d='
  M208.292755,271.927612 
     C208.329559,271.218445 208.722488,270.466583 209.459686,269.662415 
     C209.418915,270.368347 209.033890,271.126617 208.292755,271.927612 
  z'
      />
      <path
        fill='#BB5B65'
        opacity='1.000000'
        stroke='none'
        d='
  M227.672974,266.035706 
     C227.627380,266.592651 227.313354,267.290405 226.685028,268.028809 
     C226.715317,267.438446 227.059921,266.807526 227.672974,266.035706 
  z'
      />
      <path
        fill='#A54346'
        opacity='1.000000'
        stroke='none'
        d='
  M265.000549,240.006760 
     C266.348419,238.991028 267.958221,236.919479 268.990570,237.175613 
     C271.260345,237.738678 274.052612,238.992783 275.156219,240.844238 
     C277.113281,244.127579 274.502258,246.279846 271.935577,248.424667 
     C268.723541,251.108765 266.221222,248.983276 264.608795,247.193497 
     C263.217468,245.649139 261.156250,242.678757 264.713654,240.567871 
     C262.752808,245.382599 266.716736,245.925949 269.397522,247.614548 
     C270.925415,245.979645 272.315948,244.491714 273.706482,243.003769 
     C273.627106,242.458191 273.547699,241.912628 273.468323,241.367050 
     C270.645721,240.913620 267.823151,240.460190 265.000549,240.006760 
  z'
      />
      <path
        fill='#C6454C'
        opacity='1.000000'
        stroke='none'
        d='
  M265.000549,240.003372 
     C267.823151,240.460190 270.645721,240.913620 273.468323,241.367050 
     C273.547699,241.912628 273.627106,242.458191 273.706482,243.003769 
     C272.315948,244.491714 270.925415,245.979645 269.397522,247.614548 
     C266.716736,245.925949 262.752808,245.382599 264.932556,240.343979 
     C265.003937,239.992157 265.000549,239.999985 265.000549,240.003372 
  z'
      />
    </svg>
  );
};
